export const diccionario_gl = {
  hola: "Ola",
  Leida: "Lida",
  Archivada: "Arquivada",
  empleados: "Empregados",
  BloquearReserva: "Bloquear Reserva ",
  empleado: "Empregado",
  empezar: "comezar",
  empezada: "comezada",
  organizacion: "Organización",
  estructura: "Estrutura",
  organizativa: "organizativa",
  crear: "Crear",
  visualizar: "Visualizar",
  modificar: "Modificar",
  listados: "Listaxes",
  listado: "Listaxe",
  recursos: "Recursos Humanos",
  resumen: "Resumo",
  evaluados: "Avaliados",
  evaluado: "Avaliados",
  evaluaciones: "Avaliacións",
  evaluacion: "Avaliación",
  evaluada: "Avaliados",
  pruebas: "Probas",
  areas: "Áreas",
  evainiciadas: "Ava. iniciadas",
  abstencion: "Abstención",
  evarealizadas: "Ava. realizadas",
  ranking: "Ranking de empregados por avaliación",
  nombre: "Nome",
  Nombre: "Nome",
  apellidos: "Apelidos",
  area: "Área",
  estado: "Estado",
  fecha: "Data",
  resultado: "Resultado",
  todas: "Todas",
  año: "ano",
  competencias: "competencias",
  destacadas: "destacadas",
  buenas: "boas",
  normales: "normais",
  alejadas: "afastadas",
  submitida: "enviada",
  submitidas: "enviadas",
  submitir: "enviar",
  completas: "completas",
  periodos: "Períodos",
  fomulario: "Formulario",
  actualizar: "Actualizar",
  busqueda: "Campos de busca",
  rellenar: "Enche un campo co valor do empregado que queres recuperar",
  rellenar2: "Enche un campo co valor da estrutura que queres recuperar",
  limpiarcampos: "Limpar campos",
  seleccionado: "seleccionado",
  hombre: "Home",
  mujer: "Muller",
  otros: "Outros",
  genero: "Xénero",
  cargo: "Cargo",
  acceso: "Acceso",
  herramienta: "ferramenta",
  registro: "rexistro",
  telefono: "Teléfono",
  inicio: "inicio",
  Bueno: "Bo",
  Destacado: "Destacado",
  Alejado: "Afastado",
  Normal: "Normal",
  sin: "Sen",
  finalizar: "rematar",
  aviso0: "Debes responder a polo menos unha pregunta do cuestionario para comezar a avaliación",
  aviso1: "Para poder rematar a avaliación debes responder a todas as preguntas",
  aviso2: "Para enviar a avaliación debes activar o botón 'Enviar'",
  aviso3: "AVALIACIÓN ENVIADA, calquera modificación ponte en contacto co administrador",
  gerente: "Xerente",
  observaciones: "Observacións",
  aviso4: "Queres reabrir a avaliación?",
  aviso5: "Queres enviar a avaliación? Unha vez enviada xa non a poderás modificar",
  deLaOrganizacion: "DA ORGANIZACIÓN (CORE)",
  PERSONALES: "PERSOAIS",
  delPuesto: "DO POSTO",
  funcionales: "(FUNCIONAIS)",
  INTERPERSONALES: "INTERPERSOAIS",
  delPuestoFuncionales: "DO POSTO (FUNCIONAIS)",
  Email: "Email",
  Fecha_Creacion: "F. alta",
  Id: "Identificador",
  SOSBloqueo: "SOS",
  Codigo_seguridad: "Código de seguridade (máx. 5 díxitos)",
  Codigo_vecino: "Código de rexistro da comunidade",
  Cp: "C.P.",
  Poblacion: "Poboación",
  Seguro_nombre: "Compañía de Seguros",
  tooltip: "Compañía de seguros asociada á Comunidade",
  Poliza: "Póliza",
  IBAN: "Conta IBAN",
  Vecinos: "Nº Veciños",
  Pago_App: "Pagamento Mensual APP",
  Cif: "CIF",
  tip_comunidad: "Compañía de seguros asociada á Comunidade",
  listaComunidades: "Lista de comunidades",
  Direccion: "Enderezo",
  Provincia: "Provincia",
  estadoComunidad: "Estado",
  Altac365: "Alta c365",
  AltaC3652: "Alta",
  Fecha_Baja: "F. Baixa",
  Bloqueada: "Bloqueada",
  tip_Bloqueada: "Preme para bloquear/desbloquear o acceso dos usuarios á app",
  tip_Alta: "Activar/Contratar comunidade 365",
  tip_Baja: "Desactivar/Dar de baixa comunidade 365 ou ver os detalles do contrato",
  tituloBloquear: "Bloquear comunidade",
  tituloDesBloquear: "Desbloquear comunidade",
  cuerpoBloquear: "Preme aceptar para confirmar o bloqueo da comunidade",
  cuerpoDesBloquear: "Preme aceptar para confirmar o desbloqueo da comunidade",
  tip_EnvioComunidades: "Envía avisos ás comunidades previamente seleccionadas",
  ENVIAR_AVISO: "Enviar aviso",
  ENVIAR_AVISO_DOCUMENTOS: "Envío aviso documentación",
  Buscar: "Buscar",
  Buscador: "Buscador",
  Inicio: "Inicio",
  Comunidades: "Comunidades",
  Incidencias: "Incidencias",
  Gremios: "Provedores",
  Roles: "Roles",
  Notificaciones: "Notificacións",
  Despacho: "Despacho",
  Documentos: "Documentos",
  Usuarios: "Usuarios",
  DescripcionMenuInicial: "Descrición Menú Inicial",
  CIF: "CIF",
  Administracion: "Administración",
  AvisoLegal: "Aviso Legal",
  PoliticaPrivacidad: "Política de Privacidade",
  PoliticaCookies: "Política de Cookies",
  DescComunidades: "Xestión de comunidades",
  DescIncidencias: "Xestión de incidencias",
  DescGremios: "Xestión de provedores",
  DescRoles: "Xestión de roles",
  DescUsuarios: "Xestión de usuarios",
  DescNotificaciones: "Xestión de Notificacións",
  DescAdministracion: "Xestión de despacho",
  Juntas: "Xuntas",
  Votaciones: "Votacións",
  VotacionesOrdenDia: "Orde do día/Votacións",
  ZonasComunes: "Zonas Comúns",
  Documentacion: "Documentación",
  Actividades: "Actividades",
  Actividad: "Actividade",
  DescJuntas: "Xestión de Xuntas",
  DescVotaciones: "Xestión de Votacións",
  DescZonasComunes: "Xestión de Zonas Comúns",
  DescDocumentacion: "Xestión de Documentación",
  DescActividades: "Xestión de Actividades",
  Detalle: "Detalle",
  Mostrando: "Mostrando",
  a: "a",
  de: "de",
  resultados: "resultados",
  HasSeleccionado: "Seleccionaches",
  comunidades: "comunidades",
  paraAviso: "para o envío de AVISO",
  comunidad: "comunidade",
  Comunidad: "Comunidade",
  exportarPdf: "Exportar a PDF",
  exportarCsv: "Exportar a CSV",
  filasPagina: "Filas por páxina",
  comunidadesSeleccionadas: "comunidade/s seleccionada/s para aviso.",
  CERRAR: "PECHAR",
  Restaurar: "Restaurar",
  tituloFormAvisos: "Envío de avisos",
  asunto: "Asunto",
  textoAviso: "Texto do aviso",
  URLopcional: "URL opcional",
  diagoloTitulo: "Baixa da comunidade",
  diagoloBody: "Estás seguro de que queres dar de baixa a comunidade?",
  cerrar: "Pechar",
  guardarCambios: "Gardar cambios",
  diagoloBodyAviso: "Estás seguro de que queres enviar o aviso?",
  diagoloTituloAviso: "Envío de aviso",
  Guardar: "Gardar",
  CNAE: "CNAE",
  TlfnPrincipal: "Teléfono (Se hai máis dun deben ir separados por comas)",
  TlfnSecundario: "Teléfono secundario",
  Email1: "Email (Se hai máis dun deben ir separados por comas)",
  Email2: "Email 2",
  idProveedor: "Id Provedor",
  idComunidad: "Id Comunidade",
  fechaInicioContrato: "Data de inicio do contrato",
  fechaFinContrato: "Data de fin do contrato",
  observaciones: "Observacións",
  sinresultados: "Non se atoparon resultados.",
  cancelar: "Cancelar",
  aceptar: "Aceptar",
  Grupos: "Grupos",
  AccesoATodo: "Acceso a todo",
  Documentacion: "Documentación",
  ZonasReserva: "Zonas de reserva",
  JuntasYVotaciones: "Xuntas e votacións",
  Observaciones: "Observacións",
  Opciones: "Opcións",
  Acciones: "Accións",
  tip_BorrarRol: "Preme para borrar un rol",
  confirmarBorradoRol: "Marcaches un rol para dalo de baixa, desexas continuar?",
  tituloConfirmarBorradoRol: "Confirmar borrado",
  Anadir: "Engadir",
  Proveedores: "Provedores",
  SoloPara: "Só para:",
  Roles: "Roles",
  Numero: "Número",
  Portal: "Portal",
  Escalera: "Escaleira",
  Piso: "Andar",
  Letra: "Letra",
  Inquilino: "Inquilino",
  Multipropiedad: "Multipropiedade",
  Bloqueado: "Bloqueado",
  Bloq: "Bloq.",
  Usuario: "Usuario",
  AdministradorFincaColegiado: "Administrador de Leiras Colexiado",
  EmpleadoOficina: "Empregado de Oficina",
  RegistroHorario: "Fichaxes",
  Ano: "Ano",
  SeleccionaAno: "Selecciona un ano",
  Entrada: "Entrada",
  Salida: "Saída",
  Centro: "Centro",
  Horas: "Horas",
  Semana: "Semana",
  Fecha: "Data",
  TotalHoras: "Total Horas",
  Minutos: "Minutos",
  Modificar: "Modificar",
  Eliminar: "Eliminar",
  Filtrar: "Filtrar",
  tituloNuevoRegistroHorario: "Novo rexistro horario",
  confirmarBorradoRegistroHorario: "Desexas borrar o rexistro horario?",
  tituloConfirmarBorradoRistroHorario: "Borrar rexistro horario",
  EnviarCheckEmail: "Enviar Emails de verificación",
  tituloModificarRegistroHorario: "Modificar rexistro horario",
  MiCarpeta: "O meu Cartafol",
  ReseteoContrasena: "Reseteo de Contrasinal",
  TextoReseteoContrasena:
    "Vaise resetear o contrasinal do usuario, no momento en que se realice a actualización o usuario deberá acceder á aplicación co novo contrasinal",
  AnadeContrasena: "Engade o novo contrasinal (polo menos 6 díxitos)",
  Borrar: "Borrar",
  Todo: "Todo",
  Reservas: "Reservas ",
  ReservasDe: "Reservas libres de",
  Despachos: "Despachos",
  hasCambiadoDespacho: "Agora estás no despacho",
  enviarAviso: "Enviar Aviso",
  DNI: "DNI",
  descripcion: "Descrición",
  tipo: "Tipo",
  EliminarUsuario: "Eliminar Usuario",
  ConfirmarEliminarUsuario: "Desexas eliminar o usuario?",
  DetalleActividad: "Detalle da actividade",
  AnadirActividad: "Engadir actividade",
  tip_BorrarActividad: "Preme para borrar unha actividade",
  confirmarBorradoActividad:
    "Marcaches unha actividade para darlle de baixa, esta desaparecerá de todas as túas comunidades, desexas continuar?",
  tituloConfirmarBorradoActividad: "Confirmar borrado",
  AnadirRol: "Engadir Rol",
  confirmarBorradoVoto: "Marcaches un voto para borralo, desexas continuar?",
  tituloConfirmarBorradoVoto: "Confirmar borrado",
  Icono: "Icona",
  Si: "Si",
  No: "Non",
  cuerpoDesBloquearUsuario: "Desexas desbloquear o usuario ",
  tituloDesBloquearUsuario: "Desbloquear usuario ",
  cuerpoBloquearUsuario: "Desexas bloquear o usuario ",
  tituloBloquearUsuario: "Bloquear usuario ",
  Porcentaje: "Porcentaxe",
  Proveedor: "Provedor",
  SeleccionaProveedor: "Busca e selecciona un provedor...",
  UsuariosRegistradores: "Usuarios rexistradores",
  FalloPago: "O pago fallou, inténtao de novo máis tarde.",
  Gobierno: "Xunta de goberno",
  Administración: "Administración",
  Mantenimiento: "Mantemento",
  tituloEnvioCorrecto: "Resultado do envío",
  mensajeResultados: "Aviso enviado correctamente a ${var1} destinatarios",
  tip_BorrarGremio: "Preme para borrar un provedor",
  confirmarBorradoGremio: "Marcaches un provedor para dalo de baixa, desexas continuar?",
  tituloConfirmarBorradoGremio: "Confirmar borrado",
  preciosSinIva: "Todos os prezos son sen IVE.",
  preciosPorVecino:
    "Os prezos varían dependendo do número de veciños da comunidade. (Esta comunidade ten ${var1} veciños)",
  preciosPorVecinoHistorico:
    "Os prezos varían dependendo do número de veciños da comunidade. (Esta comunidade tiña ${var1} veciños no momento da contratación)",
  CreadoPor: "Creado por",
  estadoContrato: "Estado",
  asociarActividad: "A actividade agora sairá no móbil dos usuarios da comunidade.",
  desasociarActividad: "A actividade xa non sairá no móbil dos usuarios da comunidade.",
  asociarTodasActividades: "Agora sairán todas as actividades no móbil dos usuarios da comunidade",
  desasociarTodasActividades:
    "Agora non sairá ningunha actividade no móbil dos usuarios da comunidade",
  EnvioAvisoEmail: "Ademais do aviso, enviar tamén por email aos implicados",
  Codigo: "Código",
  Tipo: "Tipo",
  Actividad: "Actividade",
  Registrador: "Rexistrado por",
  tip_BorrarIncidencias: "Preme para borrar a incidencia",
  tip_BorrarNotificaciones: "Preme para borrar a notificación",
  notificacionBorrada: "Notificación borrada",
  tip_BorrarVotacion: "Preme para borrar a votación",
  tip_compartirIncidencia: "Compartir/publicar a incidencia",
  tip_ModificarRegistroHorario: "Preme para editar o rexistro",
  tip_BorrarRegistroHorario: "Preme para borrar o rexistro",
  tip_BorrarReserva: "Preme para cancelar a reserva",
  tituloCriticos: "¡Cambiáronse datos críticos!",
  bodyCriticos:
    "Devolveranse os abonos aos usuarios e borraránse as reservas futuras para poder gardar a configuración",
  Compartir: "Compartir",
  red: "Vermello",
  yellow: "Amarelo",
  green: "Verde",
  incidenciaGreen: "Incidencia pechada ou cancelada",
  incidenciaYellow: "Incidencia en curso",
  incidenciaRed: "Incidencia sen pechar dende hai 8 días ou máis",
  incidenciaRed2: "Incidencia aberta",
  ENVIAR_AVISO_EMAIL: "Enviar Email de Rexistro",
  adminDesk: {},
  SeleccionaComunidad: "Selecciona unha comunidade",
  SeleccionaEstado: "Selecciona un estado",
  SeleccionaActividad: "Selecciona unha actividade",
  SeleccionaProveedor2: "Selecciona un provedor",
  Estado: "Estado",
  ABIERTA: "ABERTA",
  CERRADA: "PECHADA",
  CANCELADA: "CANCELADA",
  ENCURSO: "EN CURSO",
  SeleccionaTipo: "Selecciona tipo",
  INCIDENCIA: "AVARÍA",
  SINIESTRO: "SINISTRO",
  SOLICITUD: "SOLICITUDE",
  CONSULTA: "CONSULTA",
  AVISO: "AVISO",
  SOS: "SOS",
  NuevaIncidencia: "Nova incidencia",
  DetalleIncidencia: "Detalle da incidencia",
  DetalleVotacion: "Detalle da votación",
  CodigoDespacho: "Código de despacho",
  CodigoComunidad: "Código de comunidade",
  SeleccionaRegistrador: "Selecciona un rexistrador",
  DescripcionIncidencia: "Descrición da incidencia (visible polos usuarios da app)",
  DatosGuardadosCorrectamente: "Datos gardados correctamente.",
  ErrorGuardarDatos: "Erro ao gardar os datos.",
  mensajeDespublicarIncidencia:
    "Ao desactivar esta opción a incidencia será privada para os veciños da comunidade.",
  mensajePublicarIncidencia:
    "Ao activar esta opción a incidencia será pública para todos os veciños da comunidade. Calquera modificación e posterior envío de aviso realizarase a todos os propietarios rexistrados.",
  Fecha_Modificacion: "Data de modificación",
  EmailProveedor: "Email provedor",
  TelefonoProveedor: "Teléfono provedor",
  ActualizaDescripcionInterna:
    "Notas internas da incidencia (visibles só polos administradores e empregados de oficina)",
  HistoricoDescripcionInterna: "Histórico da incidencia",
  HistoricoDescripcionInternaVota: "Histórico da votación",
  TituloBorrarIncidencia: "Confirmar borrado de incidencia",
  CuerpoBorrarIncidencia: "Para marcar a incidencia como borrada preme aceptar.",
  TituloCompartirIncidencia: "Confirmar compartir incidencia",
  CuerpoCompartirIncidencia: "Para compartir a incidencia preme aceptar.",
  IncidenciaBorradaCorrectamente: "Incidencia borrada correctamente",
  errorBorrarIncidencia: "Erro ao borrar a incidencia",
  errorBorrarNotificacion: "Erro ao borrar a notificación",
  NotificacionBorradaCorrectamente: "Notificación borrada correctamente",
  IncidenciaCompartidaCorrectamente: "Incidencia compartida correctamente",
  errorCompartirIncidencia: "Erro ao compartir a incidencia",
  incidenciaBorrada: "Incidencia borrada",
  votacionBorrada: "Votación borrada",
  notifiacionBorrada: "Notificación borrada",
  incidenciaCompartida: "Incidencia compartida",
  datosRefrescados: "Datos actualizados",
  Documentacion: "Documentación",
  DocumentacionAdjunta: "Documentación adxunta",
  DocumentacionAdjuntaDesc: "Documentos asociados á incidencia",
  DocumentacionAdjuntaDesc2: "Documentos asociados á notificación",
  arrastraArchivos: "Arrastra e solta aquí os teus arquivos para subilos no cartafol",
  TextoPropiedadDocumentos:
    "* Todos os documentos subidos a C365 son propiedade da comunidade, e serán traspasados en caso de cambio de administrador. Se consideras que un documento non debe ser traspasado, por favor, indícao na opción “Modificar” dese documento",
  textoConfirmarBorradoCarpeta: "Estás seguro de que queres borrar o cartafol?",
  textoConfirmarBorradoCarpetaGeneral:
    "Estás seguro de que queres borrar o cartafol? O cartafol borrarase de todas as comunidades",
  tituloConfirmarBorradoCarpeta: "Borrar cartafol:",
  textoConfirmarBorradoFichero: "Estás seguro de que queres borrar o ficheiro?",
  textoConfirmarBorradoFicheroGeneral:
    "Estás seguro de que queres borrar o ficheiro? O ficheiro borrarase de todas as comunidades",
  tituloConfirmarBorradoFichero: "Borrar ficheiro:",
  ExitoBorradoFichero: "Ficheiro borrado correctamente",
  FalloBorradoFichero: "Fallo ao borrar o ficheiro",
  Descargar: "Descargar",
  SeleccionaCompaniaSeguros: "Selecciona CIA de Seguros",
  PolizaSeguros: "Póliza de Seguros",
  Direccion_es: "Enderezo/s",
  PorcentajeTotalPropiedad: "% Total",
  TotalReservas: "Total Reservas",
  PorcPropiedad: "% Propiedade",
  ViviendaInquilino: "Vivenda con Inquilino",
  ViviendaRepLegal: "Vivenda con Rep.legal",
  propietario: "Propietario",
  inquilino: "Inquilino",
  representantelegal: "Representante Legal",
  empresa: "Empresa",
  ViviendasTipo: "Vivendas / Tipo",
  SinViviendas: "Sen vivendas",
  AltaCorrecta: "Dado de baixa correctamente.",
  FalloBajaComunidad: "Fallo ao dar de baixa a comunidade",
  ComunidadNoAlta: "A comunidade non está de alta.",
  ErrorGuardadoDatos: "Erro ao gardar os datos.",
  ErrorDatosExistentes: "A actividade ${var1} xa existe, por favor utiliza outro nome.",
  DatosActualizadosCorrectamente: "Datos actualizados correctamente",
  ActividadBorradaCorrectamente: "Actividade borrada correctamente",
  ActividadExistente: "A actividade ${var1} xa existe, por favor utiliza outro nome.",
  FechaAlta: "Data de alta",
  CodigoVecino: "Código Veciño",
  CodigoPostal: "Código Postal",
  NumeroVecinos: "Número de Veciños",
  Siniestros: "Sinistros",
  ModificacionClientes: "Recibir Solicitudes",
  ConsultasAdmin: "Recibir Consultas",
  ConsultasSeguros: "Consultas seguros",
  Categoria: "Categoría",
  Alta: "Alta",
  ConfirmarBajaComunidad:
    "Estás seguro de que queres dar de baixa a comunidade con id ${var1} de C365?",
  MaximoArchivos: "Só podes subir ata un máximo de ${var1} arquivos",
  TipoArchivoNoPermitido: "Tipo de arquivo non permitido: ${var1}",
  ArchivoTamañoMaximoSuperado: "O arquivo ${var1} excede o tamaño máximo permitido de ${var2} MB",
  ArchivosSubidosCorrectamente: "Arquivos subidos correctamente.",
  NombreCarpetaVacio: "O nome do cartafol non pode estar baleiro.",
  MismoNombreArchivoMismoNivel: "Non podes poñer o mesmo nome a un documento do mesmo nivel",
  CarpetaCreadaCorrectamente: "Cartafol creado correctamente.",
  ErrorCrearCarpeta: "Erro ao crear o cartafol.",
  CarpetaMovidaCorrectamente: "Ficheiro/Cartafol movido correctamente.",
  ErrorMoverCarpeta: "Erro ao mover o ficheiro/cartafol.",
  ErrorMoverCarpetaNoPermitido:
    "Non podes mover os cartafoles protexidos de Xuntas de propietarios e Documentación xeral",
  Carpeta03NoBorrar: "O cartafol Xuntas de Propietarios non se pode borrar/modificar",
  GuardarCambiosModificar: "Para gardar os cambios tes que modificar o arquivo",
  ErrorCambiarTransferibilidad: "Erro ao cambiar a transferibilidade",
  NombreCambiadoCorrectamente: "Nome cambiado correctamente.",
  ErrorCambiarNombre: "Erro ao cambiar o nome.",
  TipoArchivoNoPermitido: "Tipo de arquivo non permitido",
  DocumentosComunidad: "Documentos da comunidade",
  Busqueda: "Busca",
  CarpetaActual: "Cartafol actual :",
  NombreCarpeta: "Nome do cartafol",
  Descargar: "Descargar",
  Borrar: "Borrar",
  EnviarAviso: "Enviar aviso",
  AvisoDocumentosSubidosC365:
    "Todos os documentos subidos a C365 son propiedade da comunidade, e serán traspasados en caso de cambio de administrador. Se consideras que un documento non debe ser traspasado, por favor, indícao na opción “Modificar” dese documento",
  SeleccionarCarpetaMostrarDetalle: "Selecciona un cartafol para mostrar o seu detalle",
  TipoArchivoNoPermitido: "Tipo de arquivo non permitido: ${var1}",
  TodoOk: "Todo ok",
  GremioCreadoConecta: "O provedor foi creado por CAFPortal ou non ten asociada actividade",
  ProveedorBaja: "O provedor foi dado de baixa",
  CasoNoCompletado: "caso non contemplado",
  FechaAlta: "Data de Alta",
  FechaBaja: "Data de Baixa",
  GremioBorradoCorrectamente: "provedor borrado correctamente",
  Comus: "comus",
  CambioEstado: "Cambio de estado",
  NotificacionUsuarioAceptarOCancelar:
    "Podes enviar notificación ao usuario rexistrador, ao administrador e un e-mail ao provedor sobre a actualización da incidencia (EN CURSO) ou (ABERTA) preme ACEPTAR ou CANCELAR",
  CambioEstadoIncidencia: "Cambio de estado de incidencia",
  CambioEstadoIncidenciaCodigo:
    "Cambiouse de estado a incidencia con código ${var1} de ${var2} a ${var3}",
  CambioEstadoIncidenciaCodigoCerrada:
    "Cambiouse de estado a incidencia con código ${var1} foi pechada ",
  ArchivoExcedeTamano: "O arquivo excede o tamaño máximo permitido de ${var1} MB",
  CambioTipo: "Cambio de tipo",
  NotificacionIncidenciaAceptarOCancelar:
    "Podes enviar notificación ao usuario rexistrador, ao administrador e un e-mail ao provedor sobre o cambio do tipo de incidencia a SINISTRO, preme “ACEPTAR” ou “CANCELAR”.",
  CambioTipoIncidencia: "Cambio de tipo de incidencia",
  CambiadoTipoIncidenciaCodigo: "Cambiouse o tipo da incidencia con código ",
  CambiadoTipoAveriaCodigo:
    "Podes enviar notificación ao usuario rexistrador, ao administrador e un e-mail ao provedor sobre o cambio do tipo de incidencia a AVARÍA, preme “ACEPTAR” ou “CANCELAR”.",
  FechaModificacion: "Data de modificación",
  FechaCreacion: "Data de creación",
  NombreRegistrador: "Nome Rexistrador",
  ApellidoRegistrador: "Apelido Rexistrador",
  RolExiste: "O rol ${var1} xa existe, por favor utiliza outro.",
  DatosRefrescados: "Datos actualizados",
  RolBorradoCorrectamente: "Rol borrado correctamente",
  LimpiarBusqueda: "Limpar busca",
  LimpiarSeleccionado: "Limpar seleccionado",
  NoHayRoles: "Non hai roles",
  SeleccionarTodos: "Seleccionar todos",
  SeleccionarTodosFiltrado: "Seleccionar todos (filtrado)",
  RolSeleccionado: "Rol seleccionado...",
  EmailYaExiste: "O Email xa existe",
  DNIYaExiste: "O DNI xa existe",
  NumeroYaExiste: "Xa existe este número para unha xunta nesta comunidade",
  TituloYaExiste: "Xa existe este título para unha xunta nesta comunidade",
  CompletaCamposObligatiorio: "Por favor, completa todos os campos obrigatorios.",
  NoValidoIntroduceCorrecto: "O NIF/NIE non é válido, introduce un correcto",
  NoValidoIntroduceCorrecto2: "O NIF/NIE/CIF non é válido, introduce un correcto",
  NoValidoIntroduceCorrecto3: "O NIF/CIF non é válido, introduce un correcto",
  FotoBorradaCorrectamente: "Foto borrada correctamente.",
  FotoGuardadaCorrectamente: "Foto gardada correctamente.",
  AnadirUsuario: "Engadir Usuario",
  FechaIncorrecta: "A data é incorrecta.",
  NoFechasVacias: "Non se pode deixar unha das datas baleiras",
  HorasMinutos: "Horas minutos",
  RegistroHorarioBorrado: "Rexistro horario borrado correctamente",
  ErrorBorrandoRegistro: "Erro borrando rexistro",
  HoraSalidaEntradaIncorrecta: "A hora de saída non pode ser menor que a de entrada",
  TodosRolesSeleccionados: "Todos os roles foron seleccionados.",
  SeleccionarRoles: "Seleccionar roles",
  RegistroInquilinoCambiado: "Rexistro de inquilino cambiado.",
  ErrorGuardarDatos: "Erro ao gardar os datos",
  UsuarioEliminadoCorrectamente: "Usuario eliminado correctamente.",
  FalloEliminarUsuario: "Houbo un fallo borrando o usuario.",
  DNIExisteOtroUsuario: "O DNI xa existe noutro usuario",
  EmailExisteOtroUsuario: "O Email xa existe noutro usuario",
  ContrasenaActualizadaNuevaContrasena: "O contrasinal foi actualizado. Novo contrasinal: ",
  EmailActualizado: "O nome de usuario foi actualizado. Novo usuario: ",
  ErrorCambiarContrsena: "Erro ao cambiar o contrasinal.",
  ErrorCambiarEmail: "Erro ao cambiar o email/nome de usuario.",
  ErrorEnviandoEmailConfirmacion: "Erro enviando o email de verificación: ",
  EnviadoCorreoConfirmacionA: "Mandouse o correo de verificación a ",
  AltaC365: "AltaC365",
  CodigoCompletisimo: "código Completísimo",
  VotoBorradoCorrectamente: "Voto borrado correctamente",
  TipoVotacion: "Tipo de votación",
  Publicar: "Publicar",
  AperturaVotacion: "Apertura votación",
  ResultadoPublicado: "Resultado publicado",
  PublicadoPorPorciento: "Publicado por %",
  AltaComunidadConfigurar:
    "Xa tes de alta esta comunidade en c365, segue os seguintes pasos para configurar a túa comunidade:",
  BienvenidoC365: "¡Benvido a c365!",
  GeneraCodigoVecinos:
    "Fai chegar aos teus veciños o Código de Rexistro Comunidade ou o Código de Rexistro Veciño para que poidan rexistrarse na app.",
  CompletaDatosProveedoresGestionIncidencias:
    "Completa os datos dos teus provedores contratados para xestionar incidencias e sinistros.",
  MarcarActividades:
    "Marca as actividades sobre as que queiras que os teus veciños poidan pasar incidencias.",
  CompletaDocumentos: "Sube a documentación que queiras compartir cos propietarios.",
  IncidenciasYproveedores:
    "Se queres que as incidencias dunha actividade cheguen directamente a un provedor (ademais do administrador) da de alta os contratos en provedores ou en actividades.",
  SubeDocumentos: "Sube a documentación que queiras compartir cos propietarios.",
  CreaVotacionesJuntas: "Prepara votacións e xuntas cando sexa necesario.",
  CreaZonasComunes: "Configura as zonas comúns (se tes contratado o Pack de Zonas Comúns).",
  HabilitaFichajes:
    "Fai chegar aos teus veciños o Código de Rexistro Comunidade ou o Código de Rexistro Veciño para que poidan rexistrarse na app.",
  SubeDoucmentacionComparte: "Sube a documentación que queiras e compártea cos propietarios.",
  PreparaVotacionesJuntas: "Prepara votacións ou xuntas cando sexa necesario.",
  ConfiguraZonasComunes: "Configura as zonas comúns (se tes contratado o Pack de Zonas Comúns).",
  HabilitaEmleadosFichar:
    "Habilita aos empregados para que poidan fichar (se tes contratado o Pack Control Horario).",
  MarcarEnviarAviso: "Marcar para enviar aviso",
  MarcarEnviarAvisoRegistroVecino: "Marcar para enviar aviso ou mandar código de rexistro veciño",
  UsuariosActivosComunidades: "Usuarios Activos / Comunidades",
  UsuariosComunidad: "Usuarios Comunidade",
  ComunidadesActivasUsuarios: "Comunidades Activas / Usuarios",
  ComusUsuarios: "Comus Usuarios",
  IncidenciasEstados: "Incidencias/Estados ",
  EstadoNumero: "Estado/Número",
  IncidenciasAverias: "Incidencias Avarías/Tipos",
  IncidenciasTodas: "Incidencias todas ",
  CodigoDespacho: "Código de despacho",
  Refrescar: "Refrescar",
  Volver: "Volver",
  AltaDesde: "Alta dende",
  AltaHasta: "Alta ata",
  NOTIFICACIONES: "NOTIFICACIÓNS",
  CUADRODEMANDOS: "CADRO DE MANDOS",
  TODAS: "TODAS",
  ACTIVAS: "ACTIVAS",
  TODOS: "TODOS",
  ACTIVOS: "ACTIVOS",
  ABIERTA: "ABERTA",
  ENCURSO: "EN CURSO",
  CANCELADA: "CANCELADA",
  CERRADA: "PECHADA",
  Desde: "Dende",
  Hasta: "Ata",
  hasta: "ata",
  bloquearReservaTitutlo: "Bloqueo de reserva",
  CerrarSesion: "Pechar sesión",
  ErrorDemasiadosIntentos:
    "Demasiados intentos, por favor espera un rato antes de repetir a acción.",
  ErrorCamposRequeridos:
    "Os campos resaltados en vermello son obrigatorios. Para gardar os cambios deben estar cubertos.",
  ValorAntiguo: "Valor anterior",
  ValorActual: "Valor actual",
  Estado: "Estado",
  Tipo: "Tipo",
  Actividad: "Actividade",
  Proveedor: "Provedor",
  NombreRegistrador: "Rexistrador",
  NombreResponsable: "Responsable",
  Texto_publicar: "Descrición",
  Email: "Email",
  Email2: "Email 2",
  Telefono1: "Teléfono",
  Telefono2: "Teléfono 2",
  Notas: "Notas internas",
  DerechoDeReservas: "Dereito de Reservas",
  sendRegistrationCodeModaltitle: "Enviar código de Rexistro",
  sendRegistrationCodeModalConfirm:
    "Esta acción enviará por correo as instrucións e credenciais necesarios para rexistrarse na app ao usuario: ",
  sendRegistrationCodesModalConfirm:
    "Esta acción enviará por correo as instrucións e credenciais necesarios para rexistrarse na app a todos os usuarios seleccionados que non estean dados de alta no sistema.",
  sendRegistrationCodeModalSaveMail:
    "O Email foi modificado, queres gardar os cambios e continuar?",
  sendRegistrationCodeAllowedTip: "Enviar Código de rexistro por mail",
  sendRegistrationCodeDeniedTip: "Non é posible enviar sen email",
  sendRegistrationCodeSucess: "Correo enviado correctamente.",
  sendRegistrationCodeFailure:
    "Ocorreu un problema ao enviar o correo, inténtao de novo máis tarde.",
  sendRegistrationCodesSucess: "Correos enviados correctamente.",
  sendRegistrationCodesFailure:
    "Ocorreu un problema ao enviar os correos, inténtao de novo máis tarde.",
  sendRegistrationCodesMissingMail:
    " non ten correo, introdúceo no detalle ou deselecciona o usuario antes de continuar.",
  RazonSocial: "Razón Social",
  Correo: "Correo",
  PersonaDeContacto: "Persoa de contacto",
  DatosDespacho: "Datos do despacho",
  NombreYapellidos: "Nome e Apelidos",
  tituloBorradoIncidencia: "Incidencia ${var1} borrada",
  tituloCompartidoIncidencia: "Incidencia ${var1} compartida",
  mensajeBorradoIncidencia:
    "A incidencia con código ${var1}. INCIDENCIA foi borrada, preme a ligazón para ver o detalle",
  mensajeCompartidoIncidencia:
    "A incidencia con código ${var1}. INCIDENCIA foi compartida, preme a ligazón para ver o detalle",
  ResultadoPublicadoPorPorciento: "Resultado publicado por %",
  ErrorNoArchivoBorrar: "Erro, non chegou arquivo para borrar",
  PUBLICADA: "PUBLICADA",
  NOPUBLICADA: "NON PUBLICADA",
  SINOABS: "SI/NON/ABS",
  OPCIONES: "OPCIÓNS",
  NuevaOpcionDeVotacion: "Nova opción de votación",
  TituloBorrarVotacion: "Borrar votación",
  CuerpoBorrarVotacion: "Estás seguro de que queres borrar a votación?",
  AnadirVotacion: "Engadir votación",
  ElFicheroExisteNoModificar: "O ficheiro ${var1} xa existe e non se pode modificar",
  EnviarCambiosRealizados: "Vanse enviar os cambios realizados ao/s usuario/s e administrador",
  CambiarEstadoCerradaNoModificar:
    "Queres cambiar o estado a PECHADA?, se o cambias xa non poderás modificar a incidencia",
  IncidenciaActualizadaCorrectamente: "A incidencia foi actualizada correctamente",
  IncidenciaCerradaCambioAdministrador:
    "A incidencia atópase pechada, se desexas facer algún cambio ponte en contacto co administrador, grazas",
  IncidenciaCanceladaCambioAdministrador:
    "A incidencia atópase cancelada, se desexas facer algún cambio ponte en contacto co administrador, grazas",
  IncidenciaNoExiste: "A incidencia non existe.",
  BorrarEstadoAbierta: "Para poder borrar o estado da incidencia debe estar ABERTA",
  ArrastraFicheroCargarloVentana:
    "Arrastra o ficheiro ou fai clic aquí para cargalo dende a xanela",
  CargarFicheroAdjuntarFoto: "Fai clic aquí para cargar un ficheiro ou adxuntar unha foto",
  AnadeComentariosEnvialo: "Engade comentarios e envíaos",
  TextoAnadir: "Texto a engadir",
  NombreZona: "Nome da zona",
  DescripcionIncidencia: "Descrición da Incidencia",
  UltimaModificacion: "Última Modificación",
  GremioResponsable: "Provedor Responsable",
  ImagenAsociada: "Imaxe asociada: ",
  Gremio: "provedor: ",
  Incidencia: "Incidencia: ",
  CentrosTrabajo: "Centros de traballo",
  DocumentacionGeneral: "Documentación xeral",
  TodosCorreos: "Todos os correos",
  RecibirIncidencias: "Recibir Avarías",
  RecibirSiniestros: "Recibir Sinistros",
  RecibirModificacionClientes: "Recibir Solicitudes",
  RecibirConsultaAdmin: "Recibir Consulta Administrador",
  RecibirConsultaSeguros: "Recibir Consulta Seguros",
  RecibirConsultas: "Recibir Consultas",
  CategoriaUsuarioAdministrador: "Categoría Usuario-Administrador",
  Rol: "Rol",
  Fichar: "Fichar",
  ResetearContrasena: "Resetear Contrasinal",
  VerificarEmail: "Verificar correo",
  Eliminar: "Eliminar",
  DetallesUsuario: "Detalles de Usuario",
  FechaUltimoAcceso: "Data do Último Acceso",
  FechaCreacion: "Data de Creación",
  AnadirRegistro: "Engadir Rexistro",
  HorasEntrada: "Horas de Entrada",
  HorasSalida: "Horas de Saída",
  Latitud: "Latitude",
  Longitud: "Lonxitude",
  Distancia: "Distancia",
  VotacionaBorradaCorrectamente: "Votación borrada correctamente",
  AnadirCentroDeTrabajo: "Engadir Centro de traballo",
  CodigoAdministrador: "Código de Administrador",
  DatosCentroDeTrabajo: "Datos do Centro de traballo",
  CentrosTrabajoDespacho: "Centros de traballo do despacho",
  CentrosTrabajoComunidad: "Centros de traballo da comunidade",
  AvisoActividadSinProveedor:
    "Os administradores recibirán sempre as incidencias por actividade, se queres que as reciba tamén un provedor en concreto asóciao dende o detalle do provedor.",
  AlertaIncidenciaCompartida:
    "A incidencia xa foi compartida. Accede ao detalle para descompartir.",
  DocumentoAnadido: "Documento engadido",
  DocumentoEliminado: "Documento eliminado",
  textoEnviarActualizaciones:
    "Enviar emails e notificacións aos implicados avisando dos cambios na incidencia",
  tituloEnviarActualizaciones: "Confirmar gardado",
  tip_BorrarZonaComun: "Confirma a operación de borrado",
  confirmarBorradoZonaComun: "Estás seguro de que queres borrar a zona común?",
  ZonaComunBorradaCorrectamente: "Zona común borrada correctamente",
  tituloConfirmarBorrado: "Confirmar borrado",
  UsuariosDespacho: "Usuarios do Despacho",
  zonaPiscina: "Piscina",
  zonaPadel: "Pista de Padel",
  zonaTenis: "Pista de Tenis",
  zonaSalaReuniones: "Sala de Reunións",
  zonaGimnasio: "Ximnasio",
  zonaOtros: "Outros",
  zonaBarbacoa: "Barbacóa",
  zonaJardinJuegos: "Xardín/Zona de xogos",
  zonaFronton: "Frontón",
  zonaSalaInfantil: "Sala infantil",
  zonaSolarium: "Solárium",
  zonaSpa: "Spa",
  zonaPiscina2: "Piscina II",
  zonaBus: "Bus",
  CentroTrabajoCerradoCorrectamente: "Centro de traballo borrado correctamente",
  tip_BorrarCentroTrabajo: "Preme para borrar o centro de traballo",
  centroDeTrabajoBorrado: "Centro de traballo borrado",
  CuerpoBorrarCentroTrabajo: "Para borrar o centro de traballo preme aceptar.",
  TituloBorrarCentroTrabajo: "Confirmar borrado do centro de traballo",
  Historial: "Historial de reservas",
  tip_historialReservas: "Preme para ver o historial de reservas da zona común",
  HoraInicio: "Hora de inicio",
  HoraFin: "Hora de fin",
  Administrador: "Administrador",
  Oficial: "Oficial",
  Auxiliar: "Auxiliar",
  CamposVacios: "Os campos en vermello non poden estar baleiros",
  SeleccionaUnaOpcion: "Selecciona unha opción",
  AnadirUsuario: "Engadir Usuario",
  PersonasIncluidas: "Persoas incluídas",
  Enteros: "Enters",
  AnadirZonaComun: "Engadir zona común",
  DetalleZonaComun: "Detalle da zona común",
  NombreZona: "Nome da zona",
  TipoZona: "Tipo de zona",
  NumeroPersonasReserva: "Número de persoas permitidas por reserva",
  NumeroReservasPorDia: "Número de reservas por día/persoa",
  HorizonteDeFechas: "Horizonte de Datas",
  Aforo: "Capacidade",
  SlotsSeguidos: "Slots seguidos permitidos por reserva",
  AperturaDiaSiguiente: "Abrir o seguinte día de reserva a partir das:",
  LimitacionesReserva: "Permitir reservar se a reserva está activa",
  MostrarPortalPiso: "Mostrar Portal, Andar, Letra de quen reservou",
  NoPermitirReservarSiReserva: "Non permitir reservar se a reserva activa non foi consumida",
  MargenCancelacionReserva: "Marxe de cancelación de reserva",
  NumeroPersonas: "Número de persoas",
  SeleccionaNumpersonas: "Selecciona o número de persoas",
  SeleccionaNumreservas: "Selecciona o número de reservas por persoa/día",
  persona: "persoa",
  personas: "persoas",
  reserva: "reserva",
  reservas: "reservas",
  NoAplica: "Non aplica",
  dias: "días",
  dia: "día",
  SeleccionaHorizonte: "Selecciona o número de días",
  SeleccionaSlotsSeguidos: "Selecciona o número",
  Slot: "Slot",
  Slots: "Slots",
  SeleccionaPermitirReservarHora: "Selecciona a hora",
  limitaciones1: "SEN LIMITACIÓNS",
  limitaciones2: "Só a partir da hora de aplicación, para o día seguinte",
  limitaciones3: "Só o mesmo día de Reserva Activa ata consumir as do día",
  limitaciones4: "Só podes reservar cun mínimo de horas de diferenza",
  limitaciones5: "Liberar o seguinte slot despois dunhas horas",
  SeleccionaLimitaSiReserva: "Selecciona a opción",
  LimiteHoraCancelacion: "Límite de hora de cancelación",
  Resetear: "Resetear",
  ResetearVotacionBody: "Estás seguro de que queres resetear a votación?",
  VotacionResetearCorrectamente: "Votación reseteada correctamente",
  ZonaComunExiste:
    "A zona común ${var1} xa existe para a comunidade actual, por favor escribe outro nome.",
  ControlStockReservas: "Control de stock de reservas",
  visibleSoloAdmin: "VISIBLE SÓ PARA O ADMIN",
  limiteReservasUsuario: "Límite de reservas/usuario",
  tipoControlStock: "Tipo de control de stock",
  permitirReservarSinStock: "Permitir reservar na hora actual sen ter stock",
  consumirStockReservaActual: "Consumir do stock reservando na hora actual",
  consumirStockAunCancelando: "Consumir do stock aínda que se cancele a reserva",
  noConsumirStockDiaReserva: "Non consumir stock o mesmo día da reserva",
  tipoControlStock1: "Por semana",
  tipoControlStock2: "Por mes",
  tipoControlStock3: "Por ano",
  tipoControlStock4: "Por temporada",
  tipoControlStock5: "Por días",
  SeleccionaTipoControlStock: "Selecciona o tipo",
  FechaInicio: "Data de inicio",
  FechaFin: "Data de fin",
  FormaDePago: "Forma de pago",
  noConsumirDesdeDia: "Non consumir desde o día",
  noConsumirAPartir: "Non consumir stock a partir das",
  desdedia0: "Ningún día antes",
  desdedia1: "día antes",
  desdedia2: "días antes",
  SeleccionaDiasAntesSinConsumir: "Selecciona os días",
  ControlAbonos: "Control de Abonos",
  ControlInvitados: "Control de Convidados",
  AperturaAutomaticaPuerta: "Apertura automática de porta",
  GestionHorarios: "Xestión de horarios",
  NumInvitadosPorReserva: "Número máximo de convidados por reserva",
  NumConvivientesPorReserva:
    "Número máximo de conviventes non nominais por zona e reserva. Esta opción aplícase se o usuario non dispón de conviventes nominais",
  minutosApertura: "Activar apertura minutos antes da hora de reserva",
  mantenerApertura: "Manter apertura despois do peche minutos despois",
  AperturaAutomatica: "Apertura automática de porta",
  unCuartoDeHora: "1 cuarto de hora",
  mediaHora: "Media hora",
  tresCuartosHora: "3 cuartos de hora",
  unaHora: "1 hora",
  unaHoraYMedia: "1 Hora e Media",
  Horas: "Horas",
  HorasYMedia: "Horas e Media",
  HoraDeApertura: "Hora de apertura",
  HoraDeCierre: "Hora de peche",
  TamanoSlot: 'Tamaño do "slot"',
  TodasComunidades: "Todas as comunidades",
  DireccionPrincipal: "Enderezo principal",
  EstablecerHorarioFindes: "Establecer horario para fins de semana e festivos",
  CalendarioDiasFestivos: "Calendario de días festivos",
  DireccionRepetida: "O enderezo xa está no sistema",
  FestivosSeleccionados: "Días festivos",
  Enero: "Xaneiro",
  en: "xan",
  Febrero: "Febreiro",
  feb: "feb",
  Marzo: "Marzo",
  mar: "mar",
  Abril: "Abril",
  abr: "abr",
  Mayo: "Maio",
  may: "mai",
  Junio: "Xuño",
  jun: "xuñ",
  Julio: "Xullo",
  jul: "xul",
  Agosto: "Agosto",
  ago: "ago",
  Septiembre: "Setembro",
  sep: "set",
  Octubre: "Outubro",
  oct: "out",
  Noviembre: "Novembro",
  nov: "nov",
  Diciembre: "Decembro",
  dic: "dec",
  Sabado: "Sábado",
  sab: "sáb",
  Domingo: "Domingo",
  dom: "dom",
  Lunes: "Luns",
  lun: "lun",
  Martes: "Martes",
  mar: "mar",
  Miercoles: "Mércores",
  mier: "mér",
  Jueves: "Xoves",
  jue: "xov",
  Viernes: "Venres",
  vie: "ven",
  AnadirHorario: "Engadir Horario",
  QuitarHorario: "Quitar Horario",
  HoraApertura: "Hora de Apertura",
  HoraCierre: "Hora de Peche",
  Sabados: "Sábados",
  Domingos: "Domingos",
  Festivos: "Festivos",
  AnadirQuitarFestivos: "Engadir ou Quitar Días Festivos",
  Fecha_Publicacion: "Data de publicación",
  errorValidacionStock1:
    "Se usas o control de stock de reservas, o valor do límite de reservas debe ser polo menos 1",
  errorValidacionStock2:
    "a data do inicio ou fin da temporada de control de stock non pode estar baleira",
  errorValidacionStock3:
    "a data do inicio e fin da temporada de control de stock non pode ser a mesma",
  AnadirEmpleado: "Engadir Empregado",
  mensajeErrorHoras: "A hora de peche non pode ser anterior á hora de Apertura",
  confirmarBorradoProveedor: "Estás seguro de que queres borrar o provedor?",
  tituloConfirmarProveedor: "Confirmar borrado de provedor",
  UsuariosCongreso: "Usuarios CNAF2024",
  Contrasena: "Contrasinal",
  Abonos: "Táboa de Abonos",
  AbonosLuz: "Táboa de Abonos luz",
  ContratosAsoaciados: "Contratos asociados á actividade",
  SinContratos: "Sen contratos asociados ou o provedor vén de conecta",
  ConContratos: "Con contratos asociados",
  TipoCobroAbono: "Tipo de Cobro de Abono",
  TipoCobroAbonoLuz: "Tipo de Cobro de Abono de Luz",
  Abonado: "Abonado",
  CodigoAbono: "Código de Abono",
  StockActual: "Stock Actual",
  Observaciones: "Observacións",
  ReservasDisponiblesPorAbono: "Reservas dispoñibles por abono",
  CosteEuros: "Custo en euros",
  TablaUsuariosAbono: "Táboa de Usuarios Abono",
  TiposPagos: "Tipos de Pago",
  RecargaAbonoApp: "Recarga de abono da app",
  RecargaAbonoLuz: "Recarga de abono de luz",
  UsuariosAbonoLuz: "Usuarios abono de luz",
  TiposPagosLuz: "Tipos de Pago de Luz",
  HoraInicioLuz: "Hora de inicio de luz",
  HoraFinLuz: "Hora de fin de luz",
  ABIERTO: "ABERTO",
  BLOQUEADO: "BLOQUEADO",
  NoBorrarActividadGremiosAsociados:
    "Non se pode borrar a actividade porque ten provedores asociados",
  NoBorrarActividadIncidenciasAsociadas:
    "Non se pode borrar a actividade porque ten incidencias asociadas",
  TodoCorrecto: "Todo correcto",
  ContratoActividadExpiracion: "O contrato da actividade está a piques de expirar",
  DetectadoProveedorEliminadoDespacho:
    "Dende c365 detectamos un provedor eliminado no seu despacho, este provedor foi eliminado da actividade na que estaba asociado, vai ser asociado ao administrador",
  ActividadIncidenciasAbiertas: "A actividade ten incidencia/s abertas asociadas co código : ",
  NoGremiosAsociados: "Non hai provedores asociados á actividade",
  CentroDeTrabajoCreadoAnteriormente: "Ese centro de traballo xa foi creado anteriormente",
  Completado: "Completado",
  UsuarioCreadoAnteriormente: "Ese usuario xa foi creado anteriormente",
  AnchoYAltoImagen: "O ancho da imaxe debe ser de 1054 píxeles e a altura de 444 píxeles",
  NoDatosDisponibles: "Non hai datos dispoñibles",
  ReservasZonasComunes: "Reservas de zonas comúns",
  GestionReservas: "Xestión de reservas",
  CodigoDebeSerNumero: "O código debe ser un número",
  ElCodigo: "O código ",
  CoincideConOtraComunidad: " coincide coa doutra comunidade",
  VerContratos: "Ver contratos",
  ExisteEvaluacionNombreCambialo:
    "Xa existe unha avaliación con este nome, por favor cambia o nome para poder creala",
  PruebaActualizadaCorrectamente: "Proba actualizada correctamente",
  TituloEvaluacion: "Título da avaliación",
  CampoObligatorio: "este campo é obrigatorio",
  FechaCreacion: "Data de creación",
  SeleccionAreasEvaluacion: "Selecciona as áreas que aplica a avaliación",
  SeleccionPruebasEvaluacion: "Selecciona as probas para esta avaliación",
  FechaInicio: "Data de inicio",
  FechaInicialEvaluacionAntesFinal: "A data inicial da avaliación debe ser antes da data final",
  FechaFinEvaluacion: "Data de fin da avaliación",
  CambiarNombreDe: "Cambiar nome de ",
  AnadirNombreCarpetaFichero: "Engade o nome que queres poñer ao ficheiro/cartafol",
  EnvioAvisoPrueba: "envío aviso de proba",
  NombreDeUsuario: "Nome de usuario",
  SinComunidadAsociada: "Sen comunidade asociada",
  SinActividadAsociada: "Sen actividade asociada",
  Contratos: "Contratos",
  AnadirContrato: "Engadir contrato",
  seleccionarComu2: "Oculto en todas as comunidades",
  DebesSeleccionarComunidadAnadirContrato:
    "Debes seleccionar unha comunidade para engadir un contrato",
  DebesSeleccionarActividadAnadirContrato:
    "Debes seleccionar unha actividade para engadir un contrato",
  DebesSeleccionarFechaInicioAnadirContrato:
    "Debes seleccionar unha data de inicio para engadir un contrato",
  YaExisteContratoParaActividadEnComunidad:
    "Xa existe un contrato para esta actividade nesta comunidade",
  YaExisteContratoParaActividadEnComunidad2:
    "Xa existe un contrato para esta actividade nesta comunidade e no provedor actual",
  ContratoAnadidoCorrectamente: "Contrato engadido correctamente",
  ContratoEliminadoCorrectamente: "Contrato eliminado correctamente",
  Indefinido: "Indefinido",
  VerIncidenciasDe: "Ver incidencias de: ",
  DetalleProveedor: "Detalle do provedor",
  ErrorBorrarArchivoCarpeta: "Erro ao borrar o arquivo/cartafol: ",
  DocumentacionDeLaIncidencia: "Documentación da incidencia",
  SinHorasRegistradas: "Sen horas rexistradas",
  DireccionRepetida: "O enderezo está repetido",
  ValorEnterosNumerico: "O valor de enteiros debe ser numérico",
  NoDejarEnterosVacios: "Non podes deixar os enteiros baleiros",
  NoDejarReservasVacias: "Non podes deixar os dereitos de reserva baleiros",
  NoDejarDireccionVacia: "Non podes deixar o enderezo baleiro",
  RegistroRepresentanteCambiado: "Rexistro de representante cambiado.",
  ImagenUsuario: "Imaxe do usuario",
  ImagenPorDefecto: "Imaxe por defecto",
  AnadirAlMenosUnaOpcionVotacion: "Debe engadir polo menos unha opción de votación",
  NoAnadirOpcionRepetida: "Non podes engadir unha opción repetida",
  NoAnadirOpcionVacia: "Non podes engadir unha opción baleira",
  MostrarVotacionesBorradas: "Mostrar votacións borradas",
  OcultarVotacionesBorradas: "Ocultar votacións borradas",
  VotacionCerrada: "Votación pechada",
  VotacionPublicada: "Votación Publicada",
  VotacionAbiertaPublicada: "Votación aberta e publicada.",
  VerLog: "Ver log",
  AnadirBono: "Engadir novo bono",
  TituloBajaAbono: "Borrar abono",
  ConfirmarBajaAbono: "Estás seguro de que queres borrar o abono?",
  TituloBajaTipoAbono: "Borrar tipo de abono",
  TituloBajaTipoAbonoLuz: "Borrar tipo de abono de luz",
  ConfirmarBajaTipoAbono: "Estás seguro de que queres borrar o tipo de abono?",
  ConfirmarBajaTipoAbonoLuz: "Estás seguro de que queres borrar o tipo de abono de luz?",
  ProblemaNoPodidoEnviar: `Houbo un problema e non se puido enviar`,
  AvisoEnviadoCorrectamenteA: "Aviso enviado correctamente a ",
  destinatarios: " destinatarios",
  FalloEnviarAviso: "Fallo ao enviar o aviso: ",
  SoloPuedesSubirUnArchivo: "Só podes subir 1 arquivo",
  NoPuedesDejarTipoVacio: "Non podes deixar o tipo baleiro",
  FalloEnElPago: `FALLO NO PAGO`,
  ErrorAbrirNuevaVentanaPermisosVentanas:
    "Erro ao abrir a nova xanela, asegúrate de ter permisos para abrir xanelas emerxentes.",
  ContratoAceptadoPagosIniciados: "Contrato Aceptado e pagos iniciados.",
  ArrastraSueltaArchivosSubirlosCarpeta:
    "Arrastra e solta aquí os teus arquivos para subilos no cartafol:",
  AnadirTipoBono: "Engadir tipo de abono",
  AnadirTipoBonoLuz: "Engadir tipo de abono de luz",
  AlertaGuardarCambios:
    "Fixeches cambios na táboa, para que os cambios se garden fai clic en 'Gardar'.",
  ProveedorBajaEnComunidades: "O provedor foi dado de baixa na/s comunidade/s",
  FInicio: "F. Inicio",
  FFin: "F. Fin",
  Contratar: "Contratar",
  AceptarTerminosContratacion: "Aceptar termos de contratación",
  VolverPrimerPaso: "Volver 1º Paso",
  DetalleComunidad: "Detalle da Comunidade",
  Juntas: "Xuntas",
  MensajeRecargaAbonos:
    "Ponte en contacto con soporte para facilitarnos os datos da comunidade e o IBAN para configurar a plataforma de cobro",
  MensajeAperturaAutomatica:
    "Ponte en contacto con soporte para facilitarnos os datos da comunidade e o IBAN para configurar a plataforma de cobro para a instalación de apertura de porta automática",
  Reservar: "Reservar zona",
  BloquearReservas: "Bloquear Zona Común",
  seleccionaSlot: "Selecciona o/s slot/s",
  SeleccionaUsuario: "Selecciona un usuario",
  comunidadActiva: "Comunidade activa",
  comunidadInactiva: "Esta comunidade non está de alta en C365",
  comunidadBloqueada: "Lembra que esta comunidade está bloqueada",
  NumeroJunta: "Nº de Xunta",
  Titulo: "Título",
  confirmarBorradoJunta: "Preme aceptar para borrar a xunta",
  AnadirJunta: "Engadir Xunta",
  FechaCelebracion: "Data de celebración",
  tip_BorrarJunta: "Borrar xunta",
  NumeroAsistentes: "Número de asistentes",
  JuntasComunidad: "Xuntas da comunidade",
  AbrirConexion: "Abrir xunta",
  CerrarConexion: "Pechar xunta",
  Abierta: "Aberta",
  Cerrada: "Pechada",
  VideoComunidad: "Videoconferencia da comunidade",
  Entrar: "Entrar",
  Junta: "Xunta",
  TextoAyudaActividades1:
    "Selecciona as actividades sobre as que queiras que os veciños desta comunidade poidan enviar incidencias.",
  TextoAyudaActividades2:
    "Só as iconas das actividades seleccionadas aparecerán no móbil dos veciños desta comunidade.",
  TextoAyudaActividades3: "Os administradores recibirán TODAS as incidencias.",
  TextoAyudaActividades4:
    "Se queres que, ademais do administrador, un provedor reciba as incidencias dunha actividade, asóciao dende o detalle da actividade ou do provedor.",
  JuntaCerradaPestanaCerrandose:
    "A videoconferencia foi pechada, a pestana actual pecharase en 10 segundos",
  HabilitarQR: "Habilitar QR",
  irAlEnlace: "Fai clic aquí para copiar a ligazón",
  tip_BorrarUsuarioWeb: "Borrar usuario creado dende a web",
  tip_BorrarUsuarioConecta: "Non é posible borrar un usuario importado dende a integración",
  cuerpoEliminarUsuario: "Desexas eliminar o usuario ",
  tituloEliminarUsuario: "Eliminar usuario ",
  ActivarUsuarioApp: "Activar a APP para o usuario",
  TextoActivarUsuarioApp:
    "Para activar o usuario na APP por favor, escribe un contrasinal e preme aceptar.",
  EmailVerificado: "Email verificado",
  ErrorVerificacionEmail: "Erro ao verificar email",
  ErrorBajaUsuario: "Erro ao dar de baixa o usuario",
  ProcesoActivacionCompleto: "Proceso de activación de usuario completado",
  tituloBajaUsuarioAPP: "Desactivar o usuario",
  textoBajaUsuarioAPP: "Preme aceptar para dar de baixa na APP o usuario",
  ProcesoDesactivacionCompleto: "Proceso de desactivación de usuario completado",
  tip_usuarioActivado:
    "Usuario con acceso á APP. Preme se queres desactivar o acceso do usuario á APP.",
  tip_usuarioDesactivado:
    "Usuario sen acceso á APP. Preme se queres activar o acceso do usuario á APP.",
  tip_usuarioSinValidar: "Usuario rexistrado pero non validou a súa conta de email aínda.",
  amarillo_faltanDatosUsuario:
    "Falta/n o/s dato/s [${var1}], por favor, completa os datos dos usuarios desta comunidade no teu ERP para que CAFPortal poida volcalos en C365",
  amarillo_usuarioNoRegistrado: "Este usuario aínda non está rexistrado en C365",
  amarillo_usuarioViviendaNoAsignada: "Este usuario non ten vivenda asignada",
  amarillo_usuarioFalloFichaje: "Falta algún rexistro de saída nas fichaxes dos días: ${var1}",
  amarillo_usuarioCamposVacios:
    "Faltan os datos :[${var1}], por favor, completa os datos dos usuarios desta comunidade no teu ERP para que CAFPortal poida volcalos en C365",
  amarillo_usuarioNoValidado: "Este usuario non validou a súa conta de email",
  rojo_usuarioBloqueado: "Lembra que este usuario está bloqueado",
  verde_usuarioCorrecto: "Usuario correcto",
  tip_publicarJunta: "Publicar/Despublicar a xunta",
  confirmarPublicacionJunta: "Preme aceptar para publicar esta xunta",
  tituloConfirmarPublicacion: "Publicar xunta",
  confirmarDespublicacionJunta: "Preme aceptar para despublicar esta xunta",
  tituloConfirmarDespublicacion: "Despublicar xunta",
  JuntaPublicadaCorrectamente: "Xunta publicada correctamente",
  errorBorrarIncidencia: "Erro ao publicar a xunta",
  errorAbrirJunta: "Erro ao abrir a conexión",
  Asistentes: "Asistentes",
  asistentes: "asistentes",
  activado: "activado",
  desactivado: "desactivado",
  Asistente: "Asistente",
  asistente: "asistente",
  ControlAsistenciaUsuarios: "Control de asistencia de usuarios",
  Viviendas: "Vivendas",
  Vivienda: "Vivenda",
  Conexiones: "Nº Conexións",
  HoraEntrada: "Última entrada",
  HoraSalida: "Última saída",
  TotalDuracion: "Duración total (minutos)",
  confirmarBorradoAsistente: "Estás seguro de que queres borrar o asistente á xunta?",
  tituloConfirmarBorradoAsistente: "Confirmar borrado de asistente",
  RolBorradoCorrectamente: "Asistente borrado correctamente",
  tip_BorrarAsistente: "Preme para borrar un asistente",
  TipoAsistencia: "Tipo de Asistencia",
  NoCentroNoFichar: "Non podes fichar se non tes un centro de traballo asignado",
  asistirJunta: "Validar",
  CodigoCopiadoPortapapeles: "Código copiado ao portapapeis",
  ProveedorLocalAnadido:
    "Dende C365 CAFPortal detectamos un novo provedor no seu despacho creado dende o módulo local. Pode comprobar se os datos son correctos e proceder a asocialo a unha actividade",
  tip_EnvioUsuarios: "Envío de aviso aos usuarios previamente seleccionados",
  tip_EnvioCodVec: "Envío de email de rexistro aos usuarios previamente seleccionados",
  NoSoyPropietario: "Non son propietario",
  placeholderObservaciones: "Por favor indica o motivo de asistencia a esta xunta",
  ErrorGuardandoAsistencia: "Erro gardando asistencia",
  AsistenciaRegistradaConExito: "A túa asistencia foi rexistrada correctamente.",
  ReservaCompleta: "Reserva completa",
  EmpleadoComunidad: "Empregado da comunidade",
  JuntaAsociada: "Xunta Asociada",
  ErrorFechasContrato: "A data de inicio non pode ser maior que a data de fin",
  ErrorProveedorContrato: "O provedor non pode estar baleiro",
  ErrorFechaInicioMayor: "A data de inicio non pode ser maior que a data de fin",
  SinJuntaAsociada: "Sen xunta asociada",
  EmailNoValidoIntroduceCorrecto: "O Email non é válido, introduce un correcto",
  verde_UsuarioRegistrado: "Usuario rexistrado en C365",
  verde_UsuarioNoRegistrado: "Usuario non rexistrado en C365",
  ErrorEmailVacio: "Para rexistrar o usuario é necesario que o usuario dispoña dun email",
  EmailNoValido: "O email non é válido",
  Conexion: "Conexión",
  InactivarProveedorConContratos:
    "Non se pode desactivar un provedor con contratos asociados. Por favor, elimina os contratos antes de desactivar o provedor",
  TiempoAcumulado: "Tempo acumulado",
  QR: "Código QR",
  MostrarQR: "Mostrar QR",
  FormularioAsistencia: "Formulario de asistencia á xunta",
  EnlaceQRNoDisponible: "Código QR para o formulario de asistencia non habilitado.",
  verObservaciones: "Ver observacións",
  ocultarObservaciones: "Ocultar observacións",
  Enviar: "Enviar",
  tituloFormAvisosJuntas: "Enviar aviso da xunta",
  Asociados: "Contratos actuais",
  AsociadosHistoricos: "Contratos históricos",
  BorrarActividadContrato: "Eliminar contrato",
  tituloConfirmarContrato: "Confirmar eliminación de contrato",
  confirmarBorradoContrato: "Estás seguro de que queres borrar o contrato?",
  ContratosHistoricos: "Contratos históricos",
  guardarEnPdf: "Descargar QR",
  notiArchi: "Notificación arquivada correctamente",
  SinUsuarios: "Sen usuarios asociados ao centro de traballo",
  PlantillaConvocatoria: "Descargar Convocatoria",
  PlantillaActa: "Descargar Acta de Resolución",
  Convocatoria: "Convocatoria",
  Acta: "Acta",
  PrimeraConvocatoria: "Hora da Primeira Convocatoria",
  SegundaConvocatoria: "Hora da Segunda Convocatoria",
  LugarCelebracion: "Lugar de celebración",
  ORDINARIA: "Ordinaria",
  EXTRAORDINARIA: "Extraordinaria",
  ZonaBien: "Zona común correctamente configurada",
  ZonaFestivosMal:
    "A zona común ten marcado o checkbox de horario en festivos pero non ten ningún horario configurado",
  ZonaHorariosBloqueados: "A zona común ten horarios bloqueados",
  ordenDiaStandar1: "Aprobación, se procede, das contas anuais.",
  ordenDiaStandar2: "Aprobación, se procede, do orzamento ordinario de gastos e ingresos.",
  ordenDiaStandar3:
    "Substitución de cargos e nomeamento da nova Xunta de Goberno (Presidente, Vicepresidente, Vocais e Administrador)",
  ordenDiaStandar4: "Substitución de cargos en xunta de goberno",
  ordenDiaStandar5: "Rogos e preguntas",
  ordenDiaStandar1Desc: "",
  ordenDiaStandar2Desc: "",
  Convocante: "Convocante",
  juntaCerradaPorApertura:
    "Pechouse a videoconferencia previamente aberta para permitir a nova conexión",
  ErrorJuntaNoPublicada: "Non podes abrir a conexión se a xunta non está publicada",
  Abrir: "Abrir",
  Descripcion: "Descrición",
  Junta: "Xunta",
  Nombre: "Nome",
  Publicar: "Publicar",
  PublicarPorcentaje: "Publicar porcentaxe",
  PublicarResultado: "Publicar resultado",
  Roles: "Roles",
  Vacio: "Baleiro",
  Votode: "VOTO DE",
  hasioeliminao: "FOI ELIMINADO",
  QRasistencia: "QR de asistencia",
  CheckboxVotaciones: "Orde do día / Votacións",
  TooltipVotaciones: "Incluír votacións asociadas á convocatoria da xunta",
  LibresDe: "Libres de",
  BLOQUEAEDA: "BLOQUEADA",
  SalaCompleta: "Sala completa",
  BloquearDesbloquear: "Bloquear/Desbloquear todo o día",
  TituloBorrarReserva: "Cancelar reserva",
  CuerpoBorrarReserva: "Estás seguro de que queres cancelar a reserva?",
  camposCriticos: "O administrador cambiou datos críticos da zona común, recuperouse o stock de ",
  camposCriticosSinAbono:
    "O administrador cambiou datos críticos da zona común, anulouse a túa reserva/reservas: ",
  tituloCamposCriticos: "Recuperación de stock",
  tituloCamposCriticosSinAbono: "Anulación de reserva",
  AlertaNumPersonasAforo:
    "O número de persoas permitido por reserva non pode ser maior que a capacidade permitida da Zona: ${var1}",
  labelLimitaciones2: "Hora de aplicación",
  labelLimitaciones4: "Horas mínimas de diferenza",
  labelLimitaciones5: "Horas ata liberación",
  seleccionaHoraLimitacion: "Selecciona hora",
  NoAsistido: "Non asistiu",
  AlertaSeCerraraConexion: "Ao despublicar a xunta tamén se pechará a conexión.",
  Anulacion: "Anulouse a reserva",
  haCanceladoReserva: "cancelou a reserva",
  ParaElDia: "Para o día",
  para: "para",
  verDetalleEnvio: "Ver o detalle do envío",
  seHaReservado: "reservouse",
  haReservado: "reservou",
  enNombreDe: "en nome de",
  reservaZonaComun: "Confirmación de reserva",
  adminBloqueoReserva: "O administrador bloqueou a reserva",
  delDia: "do día",
  ContratoActividadExpirado: "O contrato da actividade expirou",
  SinContrato: "Sen contrato",
  rolEncontradoUsu: "O rol pódese borrar porque está asignado en usuarios nas comunidades",
  rolEncontradoVota: "O rol pódese borrar porque está asignado en votacións nas comunidades",
  enLasVotaciones: " e nas votacións",
  rolEncontradoJuntas: "O rol pódese borrar porque está asignado en xuntas nas comunidades",
  enLasJuntas: " e nas xuntas",
  ningunaDeLasPropuestas: "Ningunha opción das propostas",
  resultadoEscrutinio: "Resultado do escrutinio",
  Escrutinio1: "⅓ dos votos",
  Escrutinio2: "Maioría simple",
  Escrutinio3: "Maioría reforzada",
  Escrutinio4: "⅗ partes dos asistentes",
  Escrutinio5: "Unanimidade",
  tooltipEscrutinio2: "Máis da metade dos votos ou máis do 50% da cota de participación",
  tooltipEscrutinio3:
    "⅗ partes. Súmanse os votos dos non asistentes aos votos da maioría, e estes teñen 1 mes para revogar o seu voto. Non se pode xerar a acta ata que pasase o mes",
  NaturalezaVotacion: "Natureza da votación",
  ResultadoVotacion: "Resultado da votación",
  Aprobada: "Aprobada",
  NoAprobada: "Non aprobada",
  ConclusionesVotacion: "Conclusións da votación",
  Conclusiones: "Conclusións da votación",
  configuracionCorrecta: "Configuración correcta",
  contratoActivo: "Contrato activo",
  contratoCaducado: "Contrato caducado, ao provedor seguiranlle chegando avisos",
  Nombre: "Nome",
  Apellido: "Apelido",
  Email: "Email",
  DNI: "NIF/NIE/CIF",
  DNI2: "NIF/CIF",
  Telefono: "Teléfono",
  BuscarEnTodos: "Buscar en todos os campos",
  AnularReserva: "Anular",
  ErrorCancelarReserva: "Non se pode cancelar unha reserva cancelada / bloqueada",
  DetalleNotificacion: "Detalle da notificación",
  DocumentacionNotificacion: "Documentación da Notificación",
  IrDetalleIncidencia: "Ver incidencia relacionada",
  CuerpoBloqueoNotificacion:
    "Ao borrar a notificación ningún dos usuarios que a recibiron poderá acceder e visualizala",
  TituloBloqueoNotificacion: "Confirmar borrado da notificación",
  Leida: "Lida",
  FechaLectura: "Data de lectura",
  IdUsuario: "Id Usuario",
  DispositivosEnviados: "Dispositivos enviados",
  DispositivosError: "Dispositivos con erro",
  marcarNotificacionLeida: "Marcar ou desmarcar a notificación como lida",
  archivarNotificacion: "Arquivar ou desarquivar a notificación",
  desmarcarNotificacionLeida: 'Para desmarcar a notificación como lida preme "ACEPTAR"',
  marcarNotificacionLeida: 'Para marcar a notificación como lida preme "ACEPTAR"',
  tituloNotificacionLeida: "Marcar Notificación LIDA/NON LIDA",
  recuperarNotificacion: 'Para recuperar a notificación preme "ACEPTAR"',
  archivarNotificacion: 'Para arquivar a notificación preme "ACEPTAR"',
  tituloArchivarNotificaciones: "Arquivar notificacións",
  marcadaLeida: "Marcada ou desmarcada como lida",
  marcadaArchivada: "Marcada ou desmarcada como Arquivada",
  sinNombre: "Sen nome",
  sinApellido: "Sen apelidos",
  LEIDA: "LIDA",
  NOLEIDA: "NON LIDA",
  TostaNotificacionArchivada: "A notificación foi arquivada",
  TostaNotificacionDesarchivada: "A notificación xa non está arquivada",
  TostaNotificacionLeida: "A notificación foi marcada como lida",
  TostaNotificacionNoLeida: "A notificación foi marcada como non lida",
  TituloDispositivosUsuario: "Táboa de dispositivos do usuario ",
  conERROR: " con ERRO",
  TextoNotificacion: "Texto da notificación",
  UrlAdjunta: "Url adxunta",
  envioDispositivoCorrecto: "O aviso foi enviado e recibido correctamente no dispositivo",
  envioDispositivoIncorrecto: "O aviso non puido ser enviado e non foi recibido no dispositivo",
  errorEnvioNoti:
    "Non se puido enviar o aviso nin foi recibido en todos os posibles dispositivos (",
  errorEnvioNoti1: "Non se puido enviar o aviso nin foi recibido en ",
  errorEnvioNoti2: " dispositivos de ",
  errorEnvioNoti3: " enviados",
  exitoEnvioDispositivos: "Todos os dispositivos recibiron o aviso correctamente",
  NavegarJunta: "Navegar á xunta",
  tip_asistirJunta: "Asistencia",
  tituloAsistencia: "Detalle da asistencia",
  datosAsistencia: "Datos da asistencia",
  ASISTENCIA_REMOTA_APP_DELEGADO: "REMOTO - APP DELEGADO",
  ASISTENCIA_REMOTA: "REMOTO",
  ASISTENCIA_REMOTA_ENLACE_VIDEO: "REMOTO - LIGAZÓN VIDEO",
  ENLACE: "LIGAZÓN",
  APP: "APP",
  ASISTENCIA_FISICA_QR: "FÍSICA QR",
  ASISTENCIA_FISICA_FORMULARIO: "FÍSICA FORMULARIO",
  ASISTENCIA_FISICA_FORMULARIO_NO_PROPIETARIO: "FÍSICA FORMULARIO + NON PROPIETARIO",
  ASISTENCIA_FISICA: "FÍSICA",
  ASISTENCIA_DELEGADA: "DELEGADA",
  ASISTENCIA_: `\u00A0`,
  rojo_usuarioDesactivado: "Este usuario aínda non está rexistrado en C365",
  ErrorRecuperandoDatosAsistente: "Erro mentres se recuperaban os datos de asistente",
  DelegadoEn: "Delegado en",
  usuarioHaVotado: "O usuario votou",
  NuevoAsistente: "Novo asistente",
  NoEstasRegistradoAPP: "Non estás rexistrado na APP",
  usuarioSinVotar: "O usuario asistiu pero non votou",
  ErrorSeleccionOpcionVotacion:
    "Seleccionaches a natureza da votación unanimidade pero non seleccionaches ningunha opción",
  ErrorSeleccionResultadoVotacion:
    "Seleccionaches a natureza da votación unanimidade pero non seleccionaches ningún resultado",
  Abs: "Abs",
  JuntaSinConexion: "Reunión sen xunta",
  AutoRellenarDNI:
    "Introduce o teu DNI para auto-cubrir os teus datos se estás na base de datos da comunidade",
  UsuarioNoRegistradoEnApp:
    "Atopámoste na base de datos da comunidade, pero non estás rexistrado na APP. Queres que che enviemos un email cos pasos necesarios para que poidas darte de alta?",
  TipoVotacion: "Tipo de votación",
  QuitarAsistencia:
    "Vas quitar a asistencia á xunta, borraranse todos os votos do usuario asociados á xunta",
  VerFichajes: "Ver Fichaxes",
  PRESIDENTE: "Presidente",
  FIRMANTES: "Os abaixo asinantes",
  SeleccionaConvocante: "Selecciona convocante",
  PrimC: "1ª conv.",
  SegC: "2ª conv.",
  TipoJunta: "Tipo de asistencia",
  TituloConexion: "Título da conexión",
  AbrirEnlacePestanaNueva: "Abrir ligazón noutra pestana",
  Paso: "Paso",
  OcultarTutorial: "Ocultar tutorial",
  VerTutorial: "Ver tutorial",
  Destinatarios: "Destinatarios",
  Crear: "Crear",
  AQuienVaDirigida: "A quen vai dirixida?",
  CuandoYDonde: "Cando e onde?",
  TipRolesJuntas: "(Por defecto todos os propietarios, selecciona un ou varios roles)",
  Servicios: "Servizos",
  ProcesoAltaComunidad: "Proceso de alta da Comunidade",
  ListaContratos: "Lista de contratos",
  IrADocumentacion: "Ir á documentación da xunta",
  EstadoActual: "Estado actual",
  Publicada: "Publicada",
  NoPublicada: "Sen publicar",
  NoPublicar: "Despublicar",
  AsistentesConvocados: "Asistentes convocados",
  AsistentesConfirmados: "Asistentes confirmados",
  GenerarQR: "Xerar QR",
  QRdeLaJunta: "Código QR da Xunta",
  TipoConexion: "Tipo de conexión",
  DeshabilitarControlAsistencia: "Deshabilitar Control de Asistencia",
  HabilitarControlAsistencia: "Habilitar Control de Asistencia",
  Habilitado: "Habilitado",
  Deshabilitado: "Deshabilitado",
  TituloVotacion: "Título da votación",
  EsParaJunta: "É para unha Xunta?",
  TipJuntasVotaciones: "Se é para unha xunta selecciona unha da lista",
  TipoVotacion: "Tipo de votación",
  OpcionesVotacion: "Opcións de votación",
  NingunaDeLasOpciones: "Ningunha das opcións",
  CriteriosVotacion: "Opción maioritaria",
  AbrirVotacion: "Abrir votación",
  CerrarVotacion: "Pechar votación",
  VotacionAbierta: "Votación aberta",
  VotacionCerrada: "Votación pechada",
  NoPublicarResultado: "Despublicar resultado",
  PublicarResultado: "Publicar resultado",
  ResultadoNoPublicado: "Resultado non publicado",
  NoPublicarPorcentaje: "Non mostrar porcentaxe",
  PublicarPorcentaje: "Mostrar porcentaxe",
  PorcentajeNoPublicado: "Mostrando porcentaxe",
  PorcentajePublicado: "Non mostrando porcentaxe ",
  Votos: "Votos",
  totalVotosActa: "Total votos : ",
  sumaTotalHoras: "Suma total de horas",
  QRfichar: "QR para fichar",
  enPrep: "en",
  contratoanadir: "Engadir contrato",
  contratoanadira: "Engadir contrato a ",
  OcultarContratosCaducados: "Ocultar contratos finalizados",
  MostrarContratosCaducados: "Mostrar contratos finalizados",
  tituloEnvioAvisoVotacion: "Comunicado sobre votación",
  ContratoHisotrico: "Contrato expirado",
  RegistroDeContratros: "Rexistro de contratos",
  OcultarIconosApp: "Visualización de funcionalidades na app do móbil para esta comunidade",
  VerJuntas: "Ver Xuntas",
  Seguro: "Seguro",
  Energia: "Enerxía",
  Mantenimiento: "Mantemento",
  Reformas: "Reformas",
  VerFacturas: "Ver facturas",
  VerTutorial: "Ver tutorial",
  RegistroIncidencias: "Rexistro de incidencia",
  Compartida: "Compartida",
  SinCompartir: "Sen compartir",
  DocumentacionDeLaIncidenciaInfo: "Subir, descargar ou visualizar a documentación da incidencia",
  BotonSOS: "Botón SOS",
  NoPublicarIncidencia: "Non se pode compartir unha incidencia non publicada, pechada ou cancelada",
  RegistradoPor: "Rexistrado por",
  NoEliminarOpcionNinguna: "Ten que haber como mínimo unha opción de votación",
  ActividadesTitle: "Actividades",
  CiaSegurosComunidad: "Cia de seguros da comunidade",
  ListadoDeActividades: "Listaxe de actividades",
  DetalleComunidad: "Detalle da comunidade",
  OcultoAPP: "Oculto na APP",
  VisibleAPP: "Visible na APP",
  ZonasComunes2: "Reservas",
  PermisosDeAcceso: "Permisos de acceso",
  NIFNIE: "NIF / NIE / CIF",
  DocumentacionInfo: "Descargar ou visualizar a documentación da comunidade",
  CentrosTrabajoNavegar: "Navegar aos centros de traballo",
  anadirDirecciones: "Engadir enderezos",
  anadirDireccion: "Engadir enderezo",
  funcionesNoDisponibles:
    "* Algunhas funcionalidades non estarán dispoñibles porque o usuario non se rexistrou na app",
  solicitarConfirmacionEmail: "Solicitar Confirmación de Conta de email",
  restablecerContrasena: "Restablecer contrasinal",
  seleccionaTipo: "Selecciona o tipo",
  UsuarioNoCreado: "O usuario non foi creado, por favor, inténtao de novo",
  cambiarContrasenaUser: "Cambiar contrasinal de usuario",
  VerificarEmail: "Verificar email",
  EliminarUser: "Eliminar usuario",
  verRegistroHorario: "Ver rexistro horario",
  verFichajesUsuario: "Ver as fichaxes do usuario",
  EstadoActual: "Estado actual",
  CentrosAsignadosDetalle: "Centros de traballo asignados",
  planContratadoActivo: "Plan contratado activo:",
  actualizarModificarPack: "Actualizar / Modificar pack",
  darDeBaja: "Dar de baixa",
  descargarPrecios: "Descargar prezos",
  Plan: "Plan",
  iban: "IBAN",
  numeroIban: "Número de IBAN",
  Vecinos: "Veciños",
  Periodicidad: "Periodicidade",
  Precio: "Prezo",
  ViviendasEnComunidad: "Vivendas na comunidade",
  EmailVerificado: "Email verificado",
  envioConfirmacionEmail: "Envío de correo de confirmación",
  AvisosP: "Enviar notificación / email ao usuario.",
  FicharDesactivado: "Fichar desactivado",
  AsociarUsuariosCentroTrabajo: "Asociar usuarios ao centro de traballo",
  IncidenciasRecibiraUsuario: "De que comunidades recibirá incidencias este usuario administrador",
  AsignalRolPorComunidad: "Asignar rol por comunidade",
  DocumentacionInfoUsers: "Enviar documentación confidencial aos usuarios",
  otorgarPermisosUsuarios: "Outorgar permisos aos usuarios",
  RecibirAverias: "Recibir avarías",
  TipoDeConvocatoria: "Tipo de Xunta",
  votoDelegado: "Voto delegado",
  Leida: "Lida",
  SinLeer: "Sen ler",
  ErrorSegundaConvocatoria: "A segunda convocatoria non pode ser anterior á primeira",
  Archivada: "Arquivada",
  SinArchivar: "Sen arquivar",
  TelefonoNoValido: "O formato do teléfono non é válido, por favor introduce un correcto.",
  ViviendasSolicitadasEnComunidad: "Vivenda solicitada no rexistro na APP",
  usuarioSinInstancia: "O usuario rexistrouse dende a app pero non ten instancia asociada",
  adjudicarInstancia: "Adxudicar instancia ao usuario",
  rechazarAdjudicacion: "Rexeitar adxudicación de instancia",
  adjudicacionRechazadaExito: "Solicitude rexeitada",
  adjudicacionRechazadaFallo: "Fallo ao rexeitar a solicitude",
  confirmarRechazarAdjudicacion: "Desexas rexeitar a solicitude de adxudicación de instancia?",
  viviendaSolicitada: "Solicitada en rexistro APP",
  ResultadoEnviosNotificaciones: "Resultado dos envíos de notificacións",
  usuarioNoEncontradoEnComunidad:
    "Usuario non atopado na base de datos da comunidade, se non es propietario marca o check de non son propietario",
  JuntaYaBorrada: "A xunta xa foi borrada",
  VisualizarAPP: "Ver Iconas",
  VerIconosAPP: "Ver / Ocultar as iconas na APP",
  VisualizarAPPIconos: "Visualización de funcionalidades na app do móbil para esta comunidade",
  JuntaYaBorradaQR: "A xunta xa foi borrada, non se pode xerar o QR",
  JuntaYaBorradaPublicar: "A xunta xa foi borrada, non se pode publicar",
  ConfigurarProveedores:
    "Completa os datos dos teus provedores contratados, para xestionar avarías e sinistros.",
  CrearCentrosTrabajo:
    "Habilita aos empregados para que poidan fichar (se tes contratado o Pack Control Horario).",
  ConfigurarProveedores2: "Configuración provedores",
  MarcarActividades2: "Marcar actividades",
  AsociarProveedorAactividad: "Asociar provedor a actividade",
  SubirDocumentos: "Subir documentos",
  CrearJuntasYvotaciones: "Crear xuntas e votacións",
  AnadirZonasComunes: "Engadir zonas comúns",
  CrearCentrosDeTrabajo: "Crear centros de traballo",
  RegistroDeUsuarios: "Rexistro de usuarios",
  CrearZonas: "Crear zonas comúns",
  MostrarEnlace: "Mostrar ligazón",
  OcultarEnlace: "Ocultar ligazón",
  CrearJuntas: "Crear xuntas",
  CrearVotaciones: "Crear votacións",
  AnadirZonasComunes2: "Crear centros de traballo ",
  Totales: "Totais",
  VotoGuardadoCorrectamente: "Voto gardado correctamente",
  AnadirVotoModificar: "Engadir / Modificar voto",
  SeleccionaUsuarioVotar: "Selecciona un usuario para votar",
  SeleccionaOpcionVotar: "Selecciona unha opción para votar",
  ErrorAdjudicandoInstancia: "Ocorreu un erro adxudicando a instancia.",
  CodigoAdministracionEnUso: "O código de administración xa está en uso",
  CodigoAdminitradorNoValido: "O valor debe conter exactamente tres letras seguidas por un número.",
  usuarioConInstanciaSinAdjudicar: "O usuario ten unha instancia sen adxudicar",
  BloquearZona: "Bloquear zona",
  errorBorrarIncidencia2: "Só se poden eliminar incidencias co estado PECHADA ou CANCELADA",
  ReservaCanceladaCorrectamente: "A reserva foi cancelada correctamente",
  Contacto: "Persoa de contacto",
  enviadoscorrectosCabecera: "Notificacións enviadas correctamente",
  enviadosIncorrectosCabecera: "Notificacións enviadas con erro",
  enviadosTotalesCabecera: "Notificacións enviadas",
  enviadoTotalesCabeceraTexto: "Total de notificacións enviadas",
  Calle: "Rúa",
  ReferenciaExt: "Referencia",
  CNAEDescripcion: "Descrición CNAE",
  DatosContratoGuardadosCorrectamente: "Datos do contrato gardados correctamente",
  Propiedades: "Propiedades",
  PropietariosVecinos: "Propietarios/Inquilinos/Empresas/Rep.Legais",
  DestinatarioConsulta: "Destinatario da consulta",
  SlotReservadoDesbloquealo:
    "O slot está bloqueado. Se queres reservalo primeiro tes que desbloquealo.",
  CreadoDesde: "Creado dende",
  ProveedorRecibiraEmail: "* O provedor recibe sempre un correo cos cambios na incidencia",
  EnviarNotificaciones: "Enviar notificacións",
  enviarEmails: "Enviar emails",
  ResetearBusqueda: "Resetear busca",
  Recibos: "Recibos",
  RecibosDetalle: "Visualizar recibos",
  pagador: "Pagador",
  cobrador: "Cobrador",
  nif_cobrador: "NIF Cobrador",
  nif_pagador: "NIF Pagador",
  importe: "Importe",
  fechaVencimiento: "Data de vencemento",
  comentario: "Comentario",
  totalEnterosActa: "Total enteiros : ",
  Pagado: "Pagado",
  pdtPago: "Pendente de pago",
  totalPagado: "Total pagado",
  RegistroDeAccesos: "Rexistro de Accesos",
  AbrirConexionReunion: "Conexión de reunión",
  ErrorJuntaBorrada: "Non podes abrir a conexión se a xunta xa foi borrada",
  tooltip_emulador: "Simulación só visual para os veciños da comunidade",
  emulador: "Visualización APP para os veciños",
  GenerarQR: "Xerar QR",
  RegistroHorarioDe: "Rexistro horario do usuario :",
  Mes: "Mes:",
  Semana: "Semana:",
  ArrastrarImagen: "Arrastra ou solta aquí a imaxe",
  SeleccionaOpcion: "Selecciona unha opción",
  MostrarArchivadas: "Mostrar arquivadas",
  FiltrarUsuariosAvisos: "Filtrar usuarios para o envío de avisos",
  ContratoActual: "Contrato actual",
  ListaContratosHistoricos: "Lista de contratos históricos",
  ResolucionNecesaria: "* Resolución recomendada 1054px 444px",
  QueIncidenciasRecibira: "Que incidencias recibirá este usuario administrador?",
  seleccionaPlanNecesidades: "Selecciona o plan que máis se axuste ás túas necesidades",
  Precios: "Prezos",
  PackContratadoActual: "Pack contratado actual",
  SeleccionaFormaPago: "Selecciona a forma de pago",
  PagoMensual: "Pago Mensual",
  HasSeleccionadoPlan: "Seleccionaches o plan",
  ConFormaPago: "coa forma de pago",
  PagoAnual: "Pago Anual",
  ElPRecioTotal: "O prezo total é de",
  al: "ao",
  Siguiente: "Seguinte",
  SeleccionaOpcionFacturacion: "Selecciona unha opción de facturación",
  IBANComunidad: "IBAN da Comunidade",
  IBANAdministrador: "IBAN do Administrador",
  conLa: "coa",
  IBANElegido: "e o IBAN elixido é",
  cuentaBancariaEs: "e a conta bancaria é",
  ResumenServicios: "Resumo de Servizos Contratados",
  DetalleServicios: "A continuación, detállase un resumo dos servizos contratados",
  PlanSeleccionado: "Plan seleccionado",
  IbanAsociado: "IBAN asociado",
  PrecioTotal: "Prezo total",
  SiDeseasModificar:
    "Se desexas realizar modificacións, podes retroceder no proceso de contratación e volver ao paso correspondente.",
  Atentamente: "Atentamente",
  Empresa: "C365",
  PasoFinal: "Paso final",
  ResumenDeLosDatosContratados: "Resumo dos datos contratados",
  DescargarContrato: "Descargar contrato",
  DireccionCompleta: "Enderezo Completo",
  AlertaTitulo: "¡ALERTA! Cambios importantes na natureza da votación",
  Mensaje1: "Ao seleccionar a natureza da votación",
  Mensaje2: "e a opción",
  Mensaje3: "Asignaráselle o voto",
  Mensaje4: "a todos os votantes no momento de",
  ResultadoEnvio: "Resultado do envío",
  TokenDispositivo: "Token do dispositivo",
  ErrorTipo: "Tipo de erro",
  DetalleMensajeError: "Detalle da mensaxe de erro",
  PrimeraVezPago: "É a primeira vez que realizas un pago a cargo do",
  ConEstaCuenta: "con esta conta: ",
  PulsaConfirmarPago: "Preme confirmar para cargar o pago a esta compra e as seguintes.",
  ConfirmarIban: "Confirmar o IBAN :",
  Confirmar: "Confirmar",
  Volver: "Volver",
  VolverPrimerPaso: "Volver 1º paso",
  MostrarVotosBorradas: "Mostrar votos borrados",
  OcultarVotosBorradas: "Ocultar votos borrados",
  ElAdminHaBorradoVotacion: "O administrador borrou a votación",
  NoBorrarActividadConContratos: "Non se pode borrar unha actividade con contratos asociados",
  HazClicAquiParaAcceder: "Fai clic aquí para acceder",
  CifRepetido: "O CIF xa está en uso noutro provedor",
  SuperAdministrador: "Super Administrador",
  DeshacerCambios: "Desfacer cambios",
  Entendido: "Entendido",
  comunidadIbanDiferente: "O IBAN actual difire do que figura no contrato vixente.",
  NoTienesAcceso: "Non tes acceso a esta funcionalidade, redirixindo á páxina principal",
  MostrarDatosAdminToast: "Mostraranse os datos do despacho do administrador",
  NoMostrarDatosAdminToast: "Non se mostrarán os datos do despacho do administrador",
  MostrarDatosDespacho: "Mostrar datos do despacho",
  MostrarRecibosComunidades: "Mostrar futuros recibos da comunidade",
  MarcarFuturosRecibosComunidad: "Marcar futuros recibos da comunidade",
  MarcarFuturosRecibosUsuarios: "Marcar futuros recibos dos usuarios",
  Mostrar: "Mostrar",
  NoMostrar: "Non mostrar",
  RecibosComunidad: "Recibos da comunidade",
  RecibosUsuarios: "Recibos dos usuarios",
  VerEnLaAPP: "Ver na APP",
  PublicarFuturosRecibos: "Publicar futuros recibos",
  Publicados: "Publicados",
  SinPublicar: "Sen publicar",
  usuarioVotoBorrado: "O voto está borrado",
  ContratoGuardadoCorrectamente: "Contrato gardado correctamente",
  ArchivoBorradoCorrectamente: "Arquivo borrado correctamente",
  yaExisteEnOtroDespacho:
    "A comunidade xa existe e está de alta noutro despacho, para poder continuar terá que ser dada de baixa previamente no outro despacho.",
  FechaUltimoAcesso: "Data do último acceso",
  rojo_usuarioBloqueado: "Este usuario está bloqueado",
  ReferenciaExterna: "Referencia externa",
  titloCambiarEstadoVotacion: "Cambiar estado da votación de ",
  estasSeguroCambiarEstado: "Estás seguro de querer cambiar o estado da votación?",
  VotacionEstadoModificado: "O estado da votación foi modificado correctamente",
  FechaUltimoAcceso: "Data do último acceso",
  ReservasNoValidas: "O dereito de reserva non é válido, ten que ser 0 ou 1",
  pendienteValidarEmail: "Este usuario xa se rexistrou, está pendente de validar o seu email.",
  ErrorUsuarioNoCreado: "Non podes bloquear / desbloquear a un usuario que non está dado de alta",
  EmailRequerido: "O email é requirido para verificar o correo",
  todosCentroDeTrabajoSeleccionados: "Todos os usuarios do centro de traballo foron seleccionados",
  LimpiarBusqueda: "Limpar busca",
  limpiarSeleccionados: "Limpar seleccionado",
  seleccionarTodos: "Seleccionar todos",
  seleccionarTodosFiltrado: "Seleccionar todos (filtrado)",
  todasLasComunidadesHanSidoSeleccionadas: "Todas as comunidades foron seleccionadas",
  noHayCentroDeTrabajo: "Non hai centros de traballo",
  centrosDeTrabajo: "Centros de traballo",
  noHayComunidades: "Non hai comunidades",
  todasComunidadesPorDefecto: "Todas as comunidades por defecto",
  todosLosRolesHanSidoSeleccionados: "Todos os roles foron seleccionados",
  noHayRoles: "Non hai roles",
  seleccionarRoles: "Seleccionar roles",
  EmailIntegracion: "Email de integración",
  AltaCorrectaDemo: "Alta correcta na demo",
  CodigoIncorrectoDemo: "O código introducido non é correcto",
  IntroduceCodigoGratiws: "Introduce o código para dar de alta en C365",
  avisoBajaVecinosTitulo: "AVISO DE BAIXA",
  avisoBajaAdministradorTitulo: "AVISO DE BAIXA",
  avisoBajaVecinos:
    "O teu administrador deu de baixa a app c365 da túa comunidade, a partir deste momento só poderás visualizar na app as notificacións, ata que a túa comunidade reactive os servizos.",
  avisoBajaAdministrador:
    "Recibimos a solicitude de baixa da plataforma c365, a partir deste momento queda inactiva na plataforma",
  conservarDatos1:
    "Esta comunidade xa estivo de alta en c365, queres recuperar todos os datos desa comunidade?",
  conservarDatos2:
    "Se non conservas a configuración anterior, ten en conta que todos os usuarios terán que rexistrarse na app de novo. Se aínda así, non queres conservar os datos preme “Non Conservar”, do contrario “Conservar Datos”",
  ValidadoEnOtraComu: "O usuario está validado pero NON está de alta nesta comunidade",
  idErp: "Id. Erp",
  tokenTitulo: "A sesión está a piques de caducar",
  tokenCuerpo: "Queres renovar a sesión?",
  ErrorVerificandoEmail: "Erro verificando o email",
  ordenActualizado: "Orde actualizada correctamente",
  detectedComu:
    "Esta comunidade xa estivo de alta en c365, queres recuperar todos os datos desa comunidade?",
  RecoverOldData: "Recuperar todos os datos",
  VisualizarAPPIconosDespacho:
    "Visualización de funcionalidades na app do móbil para todas as comunidades",
  Sos: "SOS",
  Seguros: "Seguros",
  todoVisible: "Visible en todas as comunidades",
  DNIYaExisteEnLaComu: "O DNI xa existe neste despacho, por favor, introduce outro",
  ArrastrarSoltarImagen: "Arrastra ou solta aquí a imaxe",
  altaOtroDesk: "O usuario xa está de alta no despacho",
  enLasComus: " e nas comunidades: ",
  RedimensionarImagen: "A imaxe redimensionouse correctamente a 1054px x 444px",
  comunidadFalta: "Falta o campo : ",
  comunidadFaltaImportante: "Falta a asignación de ",
  comunidadFaltaImportante2: " enche-o en actividades",
  DNIotracomunidad: "Detectamos un usuario co mesmo DNI noutra comunidade",
  anadirloComunidad: "Desexas engadilo a esta comunidade?",
  votacionBorrada2: "Non podes modificar unha votación borrada",
  Responsable: "Responsable",
  SeleccionaResponsable: "Selecciona un responsable",
  ApellidoResponsable: "Apelido do responsable",
  SuscripcionDespacho: "Licenza CAFcomunidad",
  DetallesLicencia: "Ver / desactivar licenza",
  procesoActivacionComunidad: "Proceso de activación da comunidade",
  ResumenDeLaContratacion: "Resumo da contratación",
  DespachoSinIBAN:
    "Este despacho non ten un IBAN asociado, para corrixir este problema pecha esta pestana, engade o IBAN ao despacho en CAFportal e entra de novo en CAFcomunidad",
  ConfirmaDatosYAceptaContinuar: "Confirma os datos e acepta as condicións para continuar",
  ContratarActivar: "Ao contratar CAFComunidad para o despacho activarás unha",
  SuscripcionMensualDe: "subscrición mensual de",
  RecibosIBANDespacho: "Os recibos pasaranse ao IBAN do despacho",
  DespachoSinIBAN:
    "Este despacho non ten IBAN e o proceso de contratación non pode ser completado. Por favor engádeo dende CAFportal.",
  DespachoNoActivado: "O teu despacho aínda non foi activado en CAFcomunidad!",
  ActivarSuscripcionParaUsar:
    "Para poder usar CafComunidad primeiro terás que activar a subscrición. Mentres tanto poderás probar a aplicación coa comunidade de probas que tes dispoñible.",
  ContratarCAFComunidad: "Contratar CAFcomunidad",
  ContratarCafComunidadEsteDespacho: "Contratar CAFcomunidad para este despacho",
  ErrorAbrirNuevaVentana:
    "Erro ao abrir a nova xanela, asegúrate de ter permisos para abrir xanelas emerxentes.",
  ComunidadActivadaCorrectamente: "A comunidade foi activada correctamente",
  DeseasActivarComunidad: "Desexas Activar a comunidade?",
  DeseasIniciarPagosComunidad: "Desexas Iniciar Pagos da comunidade?",
  PrecioComunidad: "O prezo da comunidade",
  Con: "con",
  VecinosEsDe: "veciños é de",
  AlMes: "ao mes",
  NumeroCuentaBancaria: "O número da conta bancaria é",
  ComunidadNoIBAN: "A comunidade non dispón dun IBAN, por favor, accede a CAF portal e engádeo",
  CambiarIdioma: "Cambiar Idioma",
  ConfirmarCambiarIdioma: "Se cambias o idioma podes perder os cambios nos que estabas a traballar",
  agendarImportacionTitulo: "Axendar importación de datos",
  agendarImportacionDescripcion: "Preme aquí para concertar cita para importar os teus datos",
  //Ultima revision 04-09
};
/*
export const diccionario_gl = new Proxy(diccionario_gl_base, {
  get(target, prop) {
    // If prop is a Symbol (like Symbol.toStringTag), return the default behavior
    if (typeof prop === "symbol") {
      return Reflect.get(target, prop);
    }
    // Otherwise, return the translated value or the fallback
    return prop in target ? target[prop] : `${String(prop)} [sin trad.]`;
  }
});
*/

export const tableLocation_gl = {
  pagination: {
    labelRowsSelect: "Filas por página",
    labelDisplayedRows: "{from}-{to} de {count}",
    firstAriaLabel: "Primera página",
    firstTooltip: "Primera página",
    previousAriaLabel: "Página anterior",
    previousTooltip: "Página anterior",
    nextAriaLabel: "Siguiente página",
    nextTooltip: "Siguiente página",
    lastAriaLabel: "Última página",
    lastTooltip: "Última página",
  },
  toolbar: {
    searchTooltip: "Buscar",
    searchPlaceholder: "Buscar",
    nRowsSelected: "{0} filas(s) seleccionada(s)",
  },
  header: {
    actions: "Acciones",
  },
  body: {
    emptyDataSourceMessage: "No hay datos disponibles",
    filterRow: {
      filterTooltip: "Filtrar",
    },
    editRow: {
      saveTooltip: "Guardar",
      cancelTooltip: "Cancelar",
      deleteText: "¿Estás seguro de querer borrar esta fila?",
    },
    addTooltip: "Agregar fila",
    deleteTooltip: "Borrar fila",
  },
  edit: {
    saveTooltip: "Guardar",
    cancelTooltip: "Cancelar",
    deleteText: "¿Estás seguro de querer borrar esta fila?",
  },
  group: {
    deleteTooltip: "Borrar grupo",
    editTooltip: "Editar grupo",
    addTooltip: "Agregar grupo",
  },
};
